export const DashboardSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 11.9991L11.204 3.04409C11.644 2.60509 12.356 2.60509 12.795 3.04409L21.75 11.9991M4.5 9.74909V19.8741C4.5 20.4951 5.004 20.9991 5.625 20.9991H9.75V16.1241C9.75 15.5031 10.254 14.9991 10.875 14.9991H13.125C13.746 14.9991 14.25 15.5031 14.25 16.1241V20.9991H18.375C18.996 20.9991 19.5 20.4951 19.5 19.8741V9.74909M8.25 20.9991H16.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UserSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99805 16H11.998M7.99805 11H15.998"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.5 3.5C5.9442 3.54667 5.01661 3.71984 4.37477 4.36227C3.49609 5.24177 3.49609 6.6573 3.49609 9.48836V15.9944C3.49609 18.8255 3.49609 20.241 4.37477 21.1205C5.25345 22 6.66767 22 9.49609 22H14.4961C17.3245 22 18.7387 22 19.6174 21.1205C20.4961 20.241 20.4961 18.8255 20.4961 15.9944V9.48836C20.4961 6.6573 20.4961 5.24177 19.6174 4.36228C18.9756 3.71984 18.048 3.54667 16.4922 3.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
    />
    <path
      d="M7.49609 3.75C7.49609 2.7835 8.2796 2 9.24609 2H14.7461C15.7126 2 16.4961 2.7835 16.4961 3.75C16.4961 4.7165 15.7126 5.5 14.7461 5.5H9.24609C8.2796 5.5 7.49609 4.7165 7.49609 3.75Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);

// Organization icon for sidebar (24x24) - building icon
export const OrganizationSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 22H5C4.44772 22 4 21.5523 4 21V10C4 9.44772 4.44772 9 5 9H9V7C9 6.44772 9.44772 6 10 6H14C14.5523 6 15 6.44772 15 7V9H19C19.5523 9 20 9.44772 20 10V21C20 21.5523 19.5523 22 19 22Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 9V21M15 9V21"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12 13H12.01M12 17H12.01"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7 13H7.01M7 17H7.01"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M17 13H17.01M17 17H17.01"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

// Project icon for sidebar (24x24)
export const ProjectSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.59883 14.4H11.5988M9.59883 9.4H15.5988"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M9.25 2.5C7.55568 2.41867 6.41324 2.28784 5.49977 3.08908C4.39609 3.99347 4.39609 5.46292 4.39609 7.99072V15.9954C4.39609 18.5232 4.39609 19.9926 5.49977 20.8969C6.60345 21.8013 8.06767 21.8013 10.9961 21.8013H14.9961C17.9245 21.8013 19.3887 21.8013 20.4924 20.8969C21.5961 19.9926 21.5961 18.5232 21.5961 15.9954V7.99072C21.5961 5.46292 21.5961 3.99347 20.4924 3.08908C19.3906 2.28784 18.248 2.41867 16.5537 2.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
    />
    <path
      d="M9.39609 2.75C9.39609 1.82674 10.2228 1 11.1461 1H13.6461C14.5694 1 15.3961 1.82674 15.3961 2.75C15.3961 3.67326 14.5694 4.5 13.6461 4.5H11.1461C10.2228 4.5 9.39609 3.67326 9.39609 2.75Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);

// Manager/Users icon for sidebar (24x24)
export const ManagerSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const EditIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#F5F5F5" />
    <path
      d="M17.1586 10.7259L10.5919 17.2925C10.3419 17.5425 10.0919 18.0342 10.0419 18.3925L9.68356 20.9009C9.55022 21.8092 10.1919 22.4425 11.1002 22.3175L13.6086 21.9592C13.9586 21.9092 14.4502 21.6592 14.7086 21.4092L21.2752 14.8425C22.4086 13.7092 22.9419 12.3925 21.2752 10.7259C19.6086 9.05919 18.2919 9.59253 17.1586 10.7259Z"
      stroke="#0D0D0D"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.2168 11.6675C16.7751 13.6591 18.3335 15.2175 20.3335 15.7841"
      stroke="#0D0D0D"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DeleteIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#F5F5F5" />
    <path
      d="M15 11H17C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11ZM14 11C14 10.4696 14.2107 9.96086 14.5858 9.58579C14.9609 9.21071 15.4696 9 16 9C16.5304 9 17.0391 9.21071 17.4142 9.58579C17.7893 9.96086 18 10.4696 18 11H22C22.1326 11 22.2598 11.0527 22.3536 11.1464C22.4473 11.2402 22.5 11.3674 22.5 11.5C22.5 11.6326 22.4473 11.7598 22.3536 11.8536C22.2598 11.9473 22.1326 12 22 12H21.436L20.231 20.838C20.1493 21.4369 19.8533 21.986 19.3979 22.3835C18.9425 22.781 18.3585 23 17.754 23H14.246C13.6415 23 13.0575 22.781 12.6021 22.3835C12.1467 21.986 11.8507 21.4369 11.769 20.838L10.564 12H10C9.86739 12 9.74021 11.9473 9.64645 11.8536C9.55268 11.7598 9.5 11.6326 9.5 11.5C9.5 11.3674 9.55268 11.2402 9.64645 11.1464C9.74021 11.0527 9.86739 11 10 11H14ZM15 14.5C15 14.3674 14.9473 14.2402 14.8536 14.1464C14.7598 14.0527 14.6326 14 14.5 14C14.3674 14 14.2402 14.0527 14.1464 14.1464C14.0527 14.2402 14 14.3674 14 14.5V19.5C14 19.6326 14.0527 19.7598 14.1464 19.8536C14.2402 19.9473 14.3674 20 14.5 20C14.6326 20 14.7598 19.9473 14.8536 19.8536C14.9473 19.7598 15 19.6326 15 19.5V14.5ZM17.5 14C17.6326 14 17.7598 14.0527 17.8536 14.1464C17.9473 14.2402 18 14.3674 18 14.5V19.5C18 19.6326 17.9473 19.7598 17.8536 19.8536C17.7598 19.9473 17.6326 20 17.5 20C17.3674 20 17.2402 19.9473 17.1464 19.8536C17.0527 19.7598 17 19.6326 17 19.5V14.5C17 14.3674 17.0527 14.2402 17.1464 14.1464C17.2402 14.0527 17.3674 14 17.5 14ZM12.76 20.703C12.8091 21.0623 12.9866 21.3916 13.2598 21.6301C13.533 21.8685 13.8834 22 14.246 22H17.754C18.1168 22.0002 18.4674 21.8689 18.7408 21.6304C19.0142 21.3919 19.1919 21.0625 19.241 20.703L20.427 12H11.573L12.76 20.703Z"
      fill="#E90C0C"
    />
  </svg>
);

export const AlertIcon = (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.25 39.375C29.25 39.9717 29.0129 40.544 28.591 40.966C28.169 41.3879 27.5967 41.625 27 41.625C26.4033 41.625 25.831 41.3879 25.409 40.966C24.9871 40.544 24.75 39.9717 24.75 39.375C24.75 38.7783 24.9871 38.206 25.409 37.784C25.831 37.362 26.4033 37.125 27 37.125C27.5967 37.125 28.169 37.362 28.591 37.784C29.0129 38.206 29.25 38.7783 29.25 39.375ZM28.6875 20.8125C28.6875 20.3649 28.5097 19.9357 28.1932 19.6193C27.8768 19.3028 27.4476 19.125 27 19.125C26.5524 19.125 26.1232 19.3028 25.8068 19.6193C25.4903 19.9357 25.3125 20.3649 25.3125 20.8125V30.9375C25.3125 31.3851 25.4903 31.8143 25.8068 32.1307C26.1232 32.4472 26.5524 32.625 27 32.625C27.4476 32.625 27.8768 32.4472 28.1932 32.1307C28.5097 31.8143 28.6875 31.3851 28.6875 30.9375V20.8125Z"
      fill="#E90C0C"
    />
    <path
      d="M22.1303 7.29895C24.2971 3.5527 29.7016 3.5527 31.8683 7.29895L52.0441 42.1829C54.2108 45.9337 51.5041 50.6249 47.1728 50.6249H6.82583C2.49233 50.6249 -0.212172 45.9337 1.95458 42.1829L22.1303 7.29895ZM28.9478 8.9887C28.7494 8.64782 28.4651 8.36495 28.1232 8.16834C27.7812 7.97174 27.3937 7.86827 26.9993 7.86827C26.6049 7.86827 26.2174 7.97174 25.8755 8.16834C25.5336 8.36495 25.2492 8.64782 25.0508 8.9887L4.87733 43.8727C4.68074 44.215 4.57747 44.603 4.57787 44.9977C4.57826 45.3925 4.6823 45.7802 4.87957 46.1221C5.07685 46.464 5.36044 46.7482 5.70199 46.9461C6.04354 47.144 6.43108 47.2488 6.82583 47.2499H47.1728C47.5672 47.2486 47.9544 47.1438 48.2956 46.9459C48.6369 46.7481 48.9203 46.4643 49.1175 46.1227C49.3147 45.7811 49.4188 45.3938 49.4195 44.9993C49.4202 44.6049 49.3174 44.2172 49.1213 43.8749L28.9478 8.9887Z"
      fill="#E90C0C"
    />
  </svg>
);

export const UniSvg = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8669 22H5.2002C4.09519 22 3.2002 21.105 3.2002 20V16.2492C3.2002 15.4217 3.70936 14.6792 4.48186 14.3825L8.02598 13.0192C7.92181 12.6925 7.86681 12.3492 7.86681 12V9.9575C7.63848 9.89833 7.42764 9.77917 7.25764 9.60917C7.00763 9.35916 6.86681 9.02 6.86681 8.66666V7.66666C6.86681 7.31333 7.00764 6.97415 7.25764 6.72415C7.36014 6.62081 7.47848 6.53665 7.6068 6.47248C7.92514 4.93163 9.05179 3.64837 10.5651 3.0425C10.6984 2.44582 11.2301 2 11.8668 2H13.2001C13.8368 2 14.3685 2.44582 14.5018 3.0425C16.0151 3.64832 17.1418 4.93168 17.4601 6.47248C17.5884 6.53664 17.7067 6.62081 17.8093 6.72415C18.0593 6.97415 18.2001 7.31331 18.2001 7.66666V8.66666C18.2001 9.01998 18.0592 9.35916 17.8093 9.60917C17.6393 9.77917 17.4284 9.89834 17.2001 9.9575V12C17.2001 12.3492 17.1451 12.6925 17.0409 13.0192L20.585 14.3825C21.3575 14.6792 21.8667 15.4217 21.8667 16.2492V20C21.8667 21.105 20.9719 22 19.8669 22ZM9.20021 9.99997V12C9.20021 12.1841 9.22521 12.365 9.27438 12.5391C9.36604 12.8675 9.54104 13.1691 9.78604 13.4141C9.87687 13.505 9.97603 13.5866 10.081 13.6575C10.1202 13.6841 10.1594 13.7083 10.2002 13.7316C10.5019 13.9058 10.846 14 11.2002 14H13.8669C14.2211 14 14.5652 13.9058 14.8669 13.7316C14.9077 13.7083 14.9469 13.6841 14.986 13.6575C15.091 13.5866 15.1902 13.505 15.281 13.4141C15.526 13.1692 15.7011 12.8675 15.7927 12.5391C15.8419 12.365 15.8669 12.1841 15.8669 12V9.99997H9.20021ZM8.86687 14.3808C8.85854 14.3725 8.85104 14.365 8.84271 14.3574C8.79021 14.3041 8.73854 14.2491 8.68937 14.1924L7.2002 14.765V20.6666H11.8669V17.9833C11.1052 17.9066 10.3894 17.57 9.8427 17.0241C9.21853 16.3983 8.86687 15.5508 8.86687 14.6666L8.86687 14.3808ZM5.86697 15.2783L4.96114 15.6266C4.70364 15.7258 4.53364 15.9733 4.53364 16.2491V20C4.53364 20.3683 4.83196 20.6666 5.20031 20.6666H5.86697V15.2783ZM8.20042 8.66664H16.8671V7.66664H8.20042V8.66664ZM19.2003 20.6667H19.867C20.2353 20.6667 20.5337 20.3683 20.5337 20V16.2492C20.5337 15.9733 20.3637 15.7258 20.1062 15.6267L19.2003 15.2783V20.6667ZM17.867 14.765L16.3778 14.1925C16.3287 14.2492 16.277 14.3042 16.2245 14.3575C16.2162 14.365 16.2087 14.3725 16.2003 14.3808V14.6667C16.2003 15.5508 15.8487 16.3983 15.2245 17.0242C14.6778 17.57 13.962 17.9067 13.2003 17.9834V20.6667H17.867L17.867 14.765ZM14.7946 15.2017C14.4954 15.2883 14.1837 15.3333 13.8671 15.3333H11.2004C10.8837 15.3333 10.5721 15.2883 10.2729 15.2017C10.3654 15.5317 10.5404 15.835 10.7862 16.0808C11.1612 16.4558 11.6695 16.6667 12.2004 16.6667H12.867C13.3979 16.6667 13.9062 16.4558 14.2812 16.0808C14.527 15.835 14.7021 15.5317 14.7946 15.2017ZM16.0421 6.33339C15.7787 5.58505 15.2379 4.95506 14.5337 4.53837V6.33339H16.0421ZM10.5338 4.53837C9.82963 4.95504 9.28881 5.58503 9.02547 6.33339H10.5338V4.53837ZM13.2005 6.33339V3.33349H11.8671V6.33339H13.2005Z"
      fill="#1E3A8A"
    />
  </svg>
);
export const PostSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6V18M9 15.182L9.879 15.841C11.05 16.72 12.949 16.72 14.121 15.841C15.293 14.962 15.293 13.538 14.121 12.659C13.536 12.219 12.768 12 12 12C11.275 12 10.55 11.78 9.997 11.341C8.891 10.462 8.891 9.038 9.997 8.159C11.103 7.28 12.897 7.28 14.003 8.159L14.418 8.489M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const EventSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 10.5C15 11.2956 14.6839 12.0587 14.1213 12.6213C13.5587 13.1839 12.7956 13.5 12 13.5C11.2044 13.5 10.4413 13.1839 9.87868 12.6213C9.31607 12.0587 9 11.2956 9 10.5C9 9.70435 9.31607 8.94129 9.87868 8.37868C10.4413 7.81607 11.2044 7.5 12 7.5C12.7956 7.5 13.5587 7.81607 14.1213 8.37868C14.6839 8.94129 15 9.70435 15 10.5Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5 10.5C19.5 17.642 12 21.75 12 21.75C12 21.75 4.5 17.642 4.5 10.5C4.5 8.51088 5.29018 6.60322 6.6967 5.1967C8.10322 3.79018 10.0109 3 12 3C13.9891 3 15.8968 3.79018 17.3033 5.1967C18.7098 6.60322 19.5 8.51088 19.5 10.5Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ComSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 11.5667C22 16.8499 17.5222 21.1334 12 21.1334C11.3507 21.1343 10.7032 21.0742 10.0654 20.9545C9.60633 20.8682 9.37678 20.8251 9.21653 20.8496C9.05627 20.8741 8.82918 20.9948 8.37499 21.2364C7.09014 21.9197 5.59195 22.161 4.15111 21.893C4.69874 21.2194 5.07275 20.4112 5.23778 19.5448C5.33778 19.0148 5.09 18.5 4.71889 18.1231C3.03333 16.4115 2 14.1051 2 11.5667C2 6.28357 6.47778 2 12 2C17.5222 2 22 6.28357 22 11.5667Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M11.9955 12H12.0045M15.991 12H16M8 12H8.00897"
      stroke="#1E3A8A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const StorySvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9805 7.01562C14.9805 7.01562 15.4805 7.51562 15.9805 8.51562C15.9805 8.51562 17.5687 6.01562 18.9805 5.51562"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99485 2.0214C7.49638 1.91562 5.56612 2.20344 5.56612 2.20344C4.34727 2.29059 2.01146 2.97391 2.01148 6.9646C2.0115 10.9214 1.98564 15.7994 2.01148 17.744C2.01148 18.9321 2.7471 21.7034 5.29326 21.8519C8.3881 22.0325 13.9627 22.0709 16.5204 21.8519C17.2051 21.8133 19.4846 21.2758 19.7731 18.7957C20.072 16.2264 20.0125 14.4408 20.0125 14.0158"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.9998 7.01562C21.9998 9.77705 19.7591 12.0157 16.995 12.0157C14.2309 12.0157 11.9902 9.77705 11.9902 7.01562C11.9902 4.2542 14.2309 2.01562 16.995 2.01562C19.7591 2.01562 21.9998 4.2542 21.9998 7.01562Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M6.98047 13.0156H10.9804"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M6.98047 17.0156H14.9804"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const BoostSvg = (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 5C12.75 5.99456 12.3549 6.94839 11.6516 7.65165C10.9484 8.35491 9.99454 8.75 8.99998 8.75C8.00541 8.75 7.05159 8.35491 6.34833 7.65165C5.64506 6.94839 5.24998 5.99456 5.24998 5C5.24998 4.00544 5.64506 3.05161 6.34833 2.34835C7.05159 1.64509 8.00541 1.25 8.99998 1.25C9.99454 1.25 10.9484 1.64509 11.6516 2.34835C12.3549 3.05161 12.75 4.00544 12.75 5ZM1.50098 19.118C1.53311 17.1504 2.33731 15.2742 3.74015 13.894C5.14299 12.5139 7.03206 11.7405 8.99998 11.7405C10.9679 11.7405 12.857 12.5139 14.2598 13.894C15.6626 15.2742 16.4668 17.1504 16.499 19.118C14.1464 20.1968 11.5881 20.7535 8.99998 20.75C6.32398 20.75 3.78398 20.166 1.50098 19.118Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ModerationSvg = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F5F5F5" />
    <path
      d="M28.6364 18.5915C28.5398 18.4196 28.4432 18.2286 28.3466 18.0568C28.3466 18.0568 28.3466 18.0377 28.3273 18.0377L27.4772 16.4143L27.4579 16.357C26.1248 13.8743 26.1827 13.7215 25.8349 13.7215C25.5645 13.7215 25.4872 13.9507 25.3519 14.1798C23.8643 13.0912 22.1448 12.5183 20.3866 12.4419V11.3724C20.3866 10.8759 19.6138 10.8759 19.6138 11.3724V12.4228C17.8557 12.4992 16.1169 13.0721 14.6292 14.1607C14.494 13.9125 14.436 13.7024 14.1462 13.7024C13.8178 13.7024 14.0496 13.4541 10.8038 19.5655C9.91506 21.3225 12.0983 23.3088 14.1848 23.3088C16.0589 23.3088 18.5319 21.5326 17.392 19.3745L14.9963 14.8674C16.368 13.8361 17.9716 13.2822 19.6138 13.2058V26.4027H15.1122C13.8757 26.4027 12.8711 27.3958 12.8711 28.618V29H27.1101V28.618C27.1101 27.3958 26.1054 26.4027 24.8689 26.4027H20.3866V13.2058C22.0095 13.2822 23.6324 13.8361 24.9849 14.8674C24.8689 15.0966 22.763 19.0881 22.4925 19.5846C21.5845 21.3225 23.729 23.3088 25.8349 23.3088C27.3226 23.3088 28.5784 22.4684 29.1774 21.3034C29.699 20.4822 29.216 19.6037 28.6364 18.5915ZM14.1655 14.9247C17.0056 20.2912 17.0636 20.1576 16.909 20.7496H11.422C11.2675 20.1958 11.2868 20.3676 14.1655 14.9247ZM11.8857 21.5135H16.4453C15.2668 22.8886 13.0836 22.8886 11.8857 21.5135ZM26.2986 28.217H13.7018C13.7598 27.9687 13.895 27.7586 14.0689 27.5867C14.6485 27.0138 14.2428 27.1666 24.8689 27.1666C25.5645 27.1475 26.1248 27.6058 26.2986 28.217ZM28.5977 20.7496H23.0915C22.9176 20.1385 23.1494 20.0048 25.8349 14.9247C28.5977 20.1576 28.7523 20.2531 28.5977 20.7496ZM23.5358 21.5135H28.1147C26.9555 22.8695 24.7337 22.9077 23.5358 21.5135Z"
      fill="#13916B"
      stroke="#13916B"
      stroke-width="0.3"
    />
  </svg>
);
export const ConfigSvg = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F5F5F5" />
    <path
      d="M20 23.125C18.275 23.125 16.875 21.725 16.875 20C16.875 18.275 18.275 16.875 20 16.875C21.725 16.875 23.125 18.275 23.125 20C23.125 21.725 21.725 23.125 20 23.125ZM20 18.125C18.9667 18.125 18.125 18.9667 18.125 20C18.125 21.0333 18.9667 21.875 20 21.875C21.0333 21.875 21.875 21.0333 21.875 20C21.875 18.9667 21.0333 18.125 20 18.125Z"
      fill="#8C9521"
    />
    <path
      d="M22.6748 28.4917C22.4998 28.4917 22.3248 28.4667 22.1498 28.4251C21.6332 28.2834 21.1998 27.9584 20.9248 27.5001L20.8248 27.3334C20.3332 26.4834 19.6582 26.4834 19.1665 27.3334L19.0748 27.4917C18.7998 27.9584 18.3665 28.2917 17.8498 28.4251C17.3248 28.5667 16.7832 28.4917 16.3248 28.2167L14.8915 27.3917C14.3832 27.1001 14.0165 26.6251 13.8582 26.0501C13.7082 25.4751 13.7832 24.8834 14.0748 24.3751C14.3165 23.9501 14.3832 23.5667 14.2415 23.3251C14.0998 23.0834 13.7415 22.9417 13.2498 22.9417C12.0332 22.9417 11.0415 21.9501 11.0415 20.7334V19.2667C11.0415 18.0501 12.0332 17.0584 13.2498 17.0584C13.7415 17.0584 14.0998 16.9167 14.2415 16.6751C14.3832 16.4334 14.3248 16.0501 14.0748 15.6251C13.7832 15.1167 13.7082 14.5167 13.8582 13.9501C14.0082 13.3751 14.3748 12.9001 14.8915 12.6084L16.3332 11.7834C17.2748 11.2251 18.5165 11.5501 19.0832 12.5084L19.1832 12.6751C19.6748 13.5251 20.3498 13.5251 20.8415 12.6751L20.9332 12.5167C21.4998 11.5501 22.7415 11.2251 23.6915 11.7917L25.1248 12.6167C25.6332 12.9084 25.9998 13.3834 26.1582 13.9584C26.3082 14.5334 26.2332 15.1251 25.9415 15.6334C25.6998 16.0584 25.6332 16.4417 25.7748 16.6834C25.9165 16.9251 26.2748 17.0667 26.7665 17.0667C27.9832 17.0667 28.9748 18.0584 28.9748 19.2751V20.7417C28.9748 21.9584 27.9832 22.9501 26.7665 22.9501C26.2748 22.9501 25.9165 23.0917 25.7748 23.3334C25.6332 23.5751 25.6915 23.9584 25.9415 24.3834C26.2332 24.8917 26.3165 25.4917 26.1582 26.0584C26.0082 26.6334 25.6415 27.1084 25.1248 27.4001L23.6832 28.2251C23.3665 28.4001 23.0248 28.4917 22.6748 28.4917ZM19.9998 25.4084C20.7415 25.4084 21.4332 25.8751 21.9082 26.7001L21.9998 26.8584C22.0998 27.0334 22.2665 27.1584 22.4665 27.2084C22.6665 27.2584 22.8665 27.2334 23.0332 27.1334L24.4748 26.3001C24.6915 26.1751 24.8582 25.9667 24.9248 25.7167C24.9915 25.4667 24.9582 25.2084 24.8332 24.9917C24.3582 24.1751 24.2998 23.3334 24.6665 22.6917C25.0332 22.0501 25.7915 21.6834 26.7415 21.6834C27.2748 21.6834 27.6998 21.2584 27.6998 20.7251V19.2584C27.6998 18.7334 27.2748 18.3001 26.7415 18.3001C25.7915 18.3001 25.0332 17.9334 24.6665 17.2917C24.2998 16.6501 24.3582 15.8084 24.8332 14.9917C24.9582 14.7751 24.9915 14.5167 24.9248 14.2667C24.8582 14.0167 24.6998 13.8167 24.4832 13.6834L23.0415 12.8584C22.6832 12.6417 22.2082 12.7667 21.9915 13.1334L21.8998 13.2917C21.4248 14.1167 20.7332 14.5834 19.9915 14.5834C19.2498 14.5834 18.5582 14.1167 18.0832 13.2917L17.9915 13.1251C17.7832 12.7751 17.3165 12.6501 16.9582 12.8584L15.5165 13.6917C15.2998 13.8167 15.1332 14.0251 15.0665 14.2751C14.9998 14.5251 15.0332 14.7834 15.1582 15.0001C15.6332 15.8167 15.6915 16.6584 15.3248 17.3001C14.9582 17.9417 14.1998 18.3084 13.2498 18.3084C12.7165 18.3084 12.2915 18.7334 12.2915 19.2667V20.7334C12.2915 21.2584 12.7165 21.6917 13.2498 21.6917C14.1998 21.6917 14.9582 22.0584 15.3248 22.7001C15.6915 23.3417 15.6332 24.1834 15.1582 25.0001C15.0332 25.2167 14.9998 25.4751 15.0665 25.7251C15.1332 25.9751 15.2915 26.1751 15.5082 26.3084L16.9498 27.1334C17.1248 27.2417 17.3332 27.2667 17.5248 27.2167C17.7248 27.1667 17.8915 27.0334 17.9998 26.8584L18.0915 26.7001C18.5665 25.8834 19.2582 25.4084 19.9998 25.4084Z"
      fill="#8C9521"
    />
  </svg>
);
export const StatSvg = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F5F5F5" />
    <path
      d="M27.5 28.9583H12.5C12.1583 28.9583 11.875 28.6749 11.875 28.3333C11.875 27.9916 12.1583 27.7083 12.5 27.7083H27.5C27.8417 27.7083 28.125 27.9916 28.125 28.3333C28.125 28.6749 27.8417 28.9583 27.5 28.9583Z"
      fill="#D8C306"
    />
    <path
      d="M14.6666 26.4584H13.3333C12.5333 26.4584 11.875 25.8001 11.875 25.0001V17.8167C11.875 17.0167 12.5333 16.3584 13.3333 16.3584H14.6666C15.4666 16.3584 16.125 17.0167 16.125 17.8167V25.0001C16.125 25.8001 15.4666 26.4584 14.6666 26.4584ZM13.3333 17.6001C13.2167 17.6001 13.125 17.6917 13.125 17.8084V25.0001C13.125 25.1167 13.2167 25.2084 13.3333 25.2084H14.6666C14.7833 25.2084 14.875 25.1167 14.875 25.0001V17.8167C14.875 17.7001 14.7833 17.6084 14.6666 17.6084H13.3333V17.6001Z"
      fill="#D8C306"
    />
    <path
      d="M20.6666 26.4583H19.3333C18.5333 26.4583 17.875 25.7999 17.875 24.9999V15.1583C17.875 14.3583 18.5333 13.7 19.3333 13.7H20.6666C21.4666 13.7 22.125 14.3583 22.125 15.1583V24.9999C22.125 25.7999 21.4666 26.4583 20.6666 26.4583ZM19.3333 14.95C19.2167 14.95 19.125 15.0416 19.125 15.1583V24.9999C19.125 25.1166 19.2167 25.2083 19.3333 25.2083H20.6666C20.7833 25.2083 20.875 25.1166 20.875 24.9999V15.1583C20.875 15.0416 20.7833 14.95 20.6666 14.95H19.3333Z"
      fill="#D8C306"
    />
    <path
      d="M26.6666 26.4584H25.3333C24.5333 26.4584 23.875 25.8001 23.875 25.0001V12.5001C23.875 11.7001 24.5333 11.0417 25.3333 11.0417H26.6666C27.4666 11.0417 28.125 11.7001 28.125 12.5001V25.0001C28.125 25.8001 27.4666 26.4584 26.6666 26.4584ZM25.3333 12.2917C25.2167 12.2917 25.125 12.3834 25.125 12.5001V25.0001C25.125 25.1167 25.2167 25.2084 25.3333 25.2084H26.6666C26.7833 25.2084 26.875 25.1167 26.875 25.0001V12.5001C26.875 12.3834 26.7833 12.2917 26.6666 12.2917H25.3333Z"
      fill="#D8C306"
    />
  </svg>
);

export const SubscriptionSvg = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F5F5F5" />
    <path
      d="M27.5 28.9583H12.5C12.1583 28.9583 11.875 28.6749 11.875 28.3333C11.875 27.9916 12.1583 27.7083 12.5 27.7083H27.5C27.8417 27.7083 28.125 27.9916 28.125 28.3333C28.125 28.6749 27.8417 28.9583 27.5 28.9583Z"
      fill="#1E3A8A"
    />
    <path
      d="M14.6666 26.4584H13.3333C12.5333 26.4584 11.875 25.8001 11.875 25.0001V17.8167C11.875 17.0167 12.5333 16.3584 13.3333 16.3584H14.6666C15.4666 16.3584 16.125 17.0167 16.125 17.8167V25.0001C16.125 25.8001 15.4666 26.4584 14.6666 26.4584ZM13.3333 17.6001C13.2167 17.6001 13.125 17.6917 13.125 17.8084V25.0001C13.125 25.1167 13.2167 25.2084 13.3333 25.2084H14.6666C14.7833 25.2084 14.875 25.1167 14.875 25.0001V17.8167C14.875 17.7001 14.7833 17.6084 14.6666 17.6084H13.3333V17.6001Z"
      fill="#1E3A8A"
    />
    <path
      d="M20.6666 26.4583H19.3333C18.5333 26.4583 17.875 25.7999 17.875 24.9999V15.1583C17.875 14.3583 18.5333 13.7 19.3333 13.7H20.6666C21.4666 13.7 22.125 14.3583 22.125 15.1583V24.9999C22.125 25.7999 21.4666 26.4583 20.6666 26.4583ZM19.3333 14.95C19.2167 14.95 19.125 15.0416 19.125 15.1583V24.9999C19.125 25.1166 19.2167 25.2083 19.3333 25.2083H20.6666C20.7833 25.2083 20.875 25.1166 20.875 24.9999V15.1583C20.875 15.0416 20.7833 14.95 20.6666 14.95H19.3333Z"
      fill="#1E3A8A"
    />
    <path
      d="M26.6666 26.4584H25.3333C24.5333 26.4584 23.875 25.8001 23.875 25.0001V12.5001C23.875 11.7001 24.5333 11.0417 25.3333 11.0417H26.6666C27.4666 11.0417 28.125 11.7001 28.125 12.5001V25.0001C28.125 25.8001 27.4666 26.4584 26.6666 26.4584ZM25.3333 12.2917C25.2167 12.2917 25.125 12.3834 25.125 12.5001V25.0001C25.125 25.1167 25.2167 25.2084 25.3333 25.2084H26.6666C26.7833 25.2084 26.875 25.1167 26.875 25.0001V12.5001C26.875 12.3834 26.7833 12.2917 26.6666 12.2917H25.3333Z"
      fill="#1E3A8A"
    />
  </svg>
);

export const DownArrowSvg = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="70" height="70" rx="35" fill="#F5F5F5" />
    <path
      d="M47.1351 38.3844L35.8851 49.6344C35.769 49.7506 35.6311 49.8428 35.4794 49.9057C35.3276 49.9686 35.165 50.001 35.0007 50.001C34.8364 50.001 34.6738 49.9686 34.522 49.9057C34.3703 49.8428 34.2324 49.7506 34.1163 49.6344L22.8663 38.3844C22.6318 38.1498 22.5 37.8317 22.5 37.5C22.5 37.1683 22.6318 36.8502 22.8663 36.6156C23.1009 36.3811 23.419 36.2493 23.7507 36.2493C24.0824 36.2493 24.4005 36.3811 24.6351 36.6156L33.7507 45.7328V21.25C33.7507 20.9185 33.8824 20.6005 34.1168 20.3661C34.3512 20.1317 34.6692 20 35.0007 20C35.3322 20 35.6502 20.1317 35.8846 20.3661C36.119 20.6005 36.2507 20.9185 36.2507 21.25V45.7328L45.3663 36.6156C45.6009 36.3811 45.919 36.2493 46.2507 36.2493C46.5824 36.2493 46.9005 36.3811 47.1351 36.6156C47.3696 36.8502 47.5014 37.1683 47.5014 37.5C47.5014 37.8317 47.3696 38.1498 47.1351 38.3844Z"
      fill="#6CAD61"
    />
  </svg>
);

//Likes Page
export const FilterIcon = (
  <svg
    width="45"
    height="44"
    viewBox="0 0 45 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="44"
      height="43"
      rx="7.5"
      fill="#F8F8F8"
      stroke="#0D0D0D"
    />
    <path
      d="M13.25 16.375H13.3388C13.4752 16.911 13.7863 17.3863 14.2229 17.7257C14.6596 18.0652 15.1969 18.2494 15.75 18.2494C16.3031 18.2494 16.8404 18.0652 17.2771 17.7257C17.7137 17.3863 18.0248 16.911 18.1613 16.375H30.75C30.9158 16.375 31.0747 16.3092 31.1919 16.192C31.3092 16.0748 31.375 15.9158 31.375 15.75C31.375 15.5843 31.3092 15.4253 31.1919 15.3081C31.0747 15.1909 30.9158 15.125 30.75 15.125H18.1613C18.0248 14.589 17.7137 14.1138 17.2771 13.7743C16.8404 13.4349 16.3031 13.2506 15.75 13.2506C15.1969 13.2506 14.6596 13.4349 14.2229 13.7743C13.7863 14.1138 13.4752 14.589 13.3388 15.125H13.25C13.0842 15.125 12.9253 15.1909 12.8081 15.3081C12.6908 15.4253 12.625 15.5843 12.625 15.75C12.625 15.9158 12.6908 16.0748 12.8081 16.192C12.9253 16.3092 13.0842 16.375 13.25 16.375ZM15.75 14.5C15.9972 14.5 16.2389 14.5733 16.4445 14.7107C16.65 14.848 16.8102 15.0433 16.9048 15.2717C16.9995 15.5001 17.0242 15.7514 16.976 15.9939C16.9278 16.2364 16.8087 16.4591 16.6339 16.6339C16.4591 16.8087 16.2363 16.9278 15.9939 16.976C15.7514 17.0242 15.5001 16.9995 15.2716 16.9049C15.0432 16.8103 14.848 16.6501 14.7107 16.4445C14.5733 16.2389 14.5 15.9973 14.5 15.75C14.5 15.4185 14.6317 15.1006 14.8661 14.8661C15.1005 14.6317 15.4185 14.5 15.75 14.5ZM30.75 21.375H30.6612C30.5248 20.839 30.2137 20.3638 29.7771 20.0243C29.3404 19.6849 28.8031 19.5006 28.25 19.5006C27.6969 19.5006 27.1596 19.6849 26.7229 20.0243C26.2863 20.3638 25.9752 20.839 25.8387 21.375H13.25C13.0842 21.375 12.9253 21.4409 12.8081 21.5581C12.6908 21.6753 12.625 21.8343 12.625 22C12.625 22.1658 12.6908 22.3248 12.8081 22.442C12.9253 22.5592 13.0842 22.625 13.25 22.625H25.8387C25.9752 23.161 26.2863 23.6363 26.7229 23.9757C27.1596 24.3152 27.6969 24.4994 28.25 24.4994C28.8031 24.4994 29.3404 24.3152 29.7771 23.9757C30.2137 23.6363 30.5248 23.161 30.6612 22.625H30.75C30.9158 22.625 31.0747 22.5592 31.1919 22.442C31.3092 22.3248 31.375 22.1658 31.375 22C31.375 21.8343 31.3092 21.6753 31.1919 21.5581C31.0747 21.4409 30.9158 21.375 30.75 21.375ZM28.25 23.25C28.0028 23.25 27.7611 23.1767 27.5555 23.0394C27.35 22.902 27.1898 22.7068 27.0951 22.4784C27.0005 22.25 26.9758 21.9986 27.024 21.7562C27.0722 21.5137 27.1913 21.291 27.3661 21.1161C27.5409 20.9413 27.7637 20.8223 28.0061 20.774C28.2486 20.7258 28.4999 20.7506 28.7284 20.8452C28.9568 20.9398 29.152 21.1 29.2893 21.3056C29.4267 21.5111 29.5 21.7528 29.5 22C29.5 22.3315 29.3683 22.6495 29.1339 22.8839C28.8995 23.1183 28.5815 23.25 28.25 23.25ZM30.75 27.625H24.4113C24.2748 27.089 23.9637 26.6138 23.5271 26.2743C23.0904 25.9349 22.5531 25.7506 22 25.7506C21.4469 25.7506 20.9096 25.9349 20.4729 26.2743C20.0363 26.6138 19.7252 27.089 19.5887 27.625H13.25C13.0842 27.625 12.9253 27.6909 12.8081 27.8081C12.6908 27.9253 12.625 28.0843 12.625 28.25C12.625 28.4158 12.6908 28.5748 12.8081 28.692C12.9253 28.8092 13.0842 28.875 13.25 28.875H19.5887C19.7252 29.411 20.0363 29.8863 20.4729 30.2257C20.9096 30.5652 21.4469 30.7494 22 30.7494C22.5531 30.7494 23.0904 30.5652 23.5271 30.2257C23.9637 29.8863 24.2748 29.411 24.4113 28.875H30.75C30.9158 28.875 31.0747 28.8092 31.1919 28.692C31.3092 28.5748 31.375 28.4158 31.375 28.25C31.375 28.0843 31.3092 27.9253 31.1919 27.8081C31.0747 27.6909 30.9158 27.625 30.75 27.625ZM22 29.5C21.7528 29.5 21.5111 29.4267 21.3055 29.2894C21.1 29.152 20.9398 28.9568 20.8451 28.7284C20.7505 28.5 20.7258 28.2486 20.774 28.0062C20.8222 27.7637 20.9413 27.541 21.1161 27.3661C21.2909 27.1913 21.5137 27.0723 21.7561 27.024C21.9986 26.9758 22.2499 27.0006 22.4784 27.0952C22.7068 27.1898 22.902 27.35 23.0393 27.5556C23.1767 27.7611 23.25 28.0028 23.25 28.25C23.25 28.5815 23.1183 28.8995 22.8839 29.1339C22.6495 29.3683 22.3315 29.5 22 29.5Z"
      fill="#0D0D0D"
    />
  </svg>
);

export const CalenderIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="50" height="50" rx="25" fill="#FAFAFA" />
    <path
      d="M21 18.75C20.59 18.75 20.25 18.41 20.25 18V15C20.25 14.59 20.59 14.25 21 14.25C21.41 14.25 21.75 14.59 21.75 15V18C21.75 18.41 21.41 18.75 21 18.75Z"
      fill="#292D32"
    />
    <path
      d="M29 18.75C28.59 18.75 28.25 18.41 28.25 18V15C28.25 14.59 28.59 14.25 29 14.25C29.41 14.25 29.75 14.59 29.75 15V18C29.75 18.41 29.41 18.75 29 18.75Z"
      fill="#292D32"
    />
    <path
      d="M21.5 27.5001C21.37 27.5001 21.24 27.4701 21.12 27.4201C20.99 27.3701 20.89 27.3001 20.79 27.2101C20.61 27.0201 20.5 26.7701 20.5 26.5001C20.5 26.3701 20.53 26.2401 20.58 26.1201C20.63 26.0001 20.7 25.8901 20.79 25.7901C20.89 25.7001 20.99 25.6301 21.12 25.5801C21.48 25.4301 21.93 25.5101 22.21 25.7901C22.39 25.9801 22.5 26.2401 22.5 26.5001C22.5 26.5601 22.49 26.6301 22.48 26.7001C22.47 26.7601 22.45 26.8201 22.42 26.8801C22.4 26.9401 22.37 27.0001 22.33 27.0601C22.3 27.1101 22.25 27.1601 22.21 27.2101C22.02 27.3901 21.76 27.5001 21.5 27.5001Z"
      fill="#292D32"
    />
    <path
      d="M25 27.4999C24.87 27.4999 24.74 27.4699 24.62 27.4199C24.49 27.3699 24.39 27.2999 24.29 27.2099C24.11 27.0199 24 26.7699 24 26.4999C24 26.3699 24.03 26.2399 24.08 26.1199C24.13 25.9999 24.2 25.8899 24.29 25.7899C24.39 25.6999 24.49 25.6299 24.62 25.5799C24.98 25.4199 25.43 25.5099 25.71 25.7899C25.89 25.9799 26 26.2399 26 26.4999C26 26.5599 25.99 26.6299 25.98 26.6999C25.97 26.7599 25.95 26.8199 25.92 26.8799C25.9 26.9399 25.87 26.9999 25.83 27.0599C25.8 27.1099 25.75 27.1599 25.71 27.2099C25.52 27.3899 25.26 27.4999 25 27.4999Z"
      fill="#292D32"
    />
    <path
      d="M28.5 27.4999C28.37 27.4999 28.24 27.4699 28.12 27.4199C27.99 27.3699 27.89 27.2999 27.79 27.2099C27.75 27.1599 27.71 27.1099 27.67 27.0599C27.63 26.9999 27.6 26.9399 27.58 26.8799C27.55 26.8199 27.53 26.7599 27.52 26.6999C27.51 26.6299 27.5 26.5599 27.5 26.4999C27.5 26.2399 27.61 25.9799 27.79 25.7899C27.89 25.6999 27.99 25.6299 28.12 25.5799C28.49 25.4199 28.93 25.5099 29.21 25.7899C29.39 25.9799 29.5 26.2399 29.5 26.4999C29.5 26.5599 29.49 26.6299 29.48 26.6999C29.47 26.7599 29.45 26.8199 29.42 26.8799C29.4 26.9399 29.37 26.9999 29.33 27.0599C29.3 27.1099 29.25 27.1599 29.21 27.2099C29.02 27.3899 28.76 27.4999 28.5 27.4999Z"
      fill="#292D32"
    />
    <path
      d="M21.5 30.9999C21.37 30.9999 21.24 30.97 21.12 30.92C21 30.87 20.89 30.7999 20.79 30.7099C20.61 30.5199 20.5 30.2599 20.5 29.9999C20.5 29.8699 20.53 29.7399 20.58 29.6199C20.63 29.4899 20.7 29.38 20.79 29.29C21.16 28.92 21.84 28.92 22.21 29.29C22.39 29.48 22.5 29.7399 22.5 29.9999C22.5 30.2599 22.39 30.5199 22.21 30.7099C22.02 30.8899 21.76 30.9999 21.5 30.9999Z"
      fill="#292D32"
    />
    <path
      d="M25 30.9999C24.74 30.9999 24.48 30.8899 24.29 30.7099C24.11 30.5199 24 30.2599 24 29.9999C24 29.8699 24.03 29.7399 24.08 29.6199C24.13 29.4899 24.2 29.38 24.29 29.29C24.66 28.92 25.34 28.92 25.71 29.29C25.8 29.38 25.87 29.4899 25.92 29.6199C25.97 29.7399 26 29.8699 26 29.9999C26 30.2599 25.89 30.5199 25.71 30.7099C25.52 30.8899 25.26 30.9999 25 30.9999Z"
      fill="#292D32"
    />
    <path
      d="M28.5 30.9999C28.24 30.9999 27.98 30.8899 27.79 30.7099C27.7 30.6199 27.63 30.5099 27.58 30.3799C27.53 30.2599 27.5 30.1299 27.5 29.9999C27.5 29.8699 27.53 29.7399 27.58 29.6199C27.63 29.4899 27.7 29.3799 27.79 29.2899C28.02 29.0599 28.37 28.9499 28.69 29.0199C28.76 29.0299 28.82 29.0499 28.88 29.0799C28.94 29.0999 29 29.1299 29.06 29.1699C29.11 29.1999 29.16 29.2499 29.21 29.2899C29.39 29.4799 29.5 29.7399 29.5 29.9999C29.5 30.2599 29.39 30.5199 29.21 30.7099C29.02 30.8899 28.76 30.9999 28.5 30.9999Z"
      fill="#292D32"
    />
    <path
      d="M33.5 22.8398H16.5C16.09 22.8398 15.75 22.4998 15.75 22.0898C15.75 21.6798 16.09 21.3398 16.5 21.3398H33.5C33.91 21.3398 34.25 21.6798 34.25 22.0898C34.25 22.4998 33.91 22.8398 33.5 22.8398Z"
      fill="#292D32"
    />
    <path
      d="M29 35.75H21C17.35 35.75 15.25 33.65 15.25 30V21.5C15.25 17.85 17.35 15.75 21 15.75H29C32.65 15.75 34.75 17.85 34.75 21.5V30C34.75 33.65 32.65 35.75 29 35.75ZM21 17.25C18.14 17.25 16.75 18.64 16.75 21.5V30C16.75 32.86 18.14 34.25 21 34.25H29C31.86 34.25 33.25 32.86 33.25 30V21.5C33.25 18.64 31.86 17.25 29 17.25H21Z"
      fill="#292D32"
    />
  </svg>
);
export const CMSvg = (
  <svg
    width="27"
    height="25"
    viewBox="0 0 27 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.96582 5.14318C0.96582 3.91173 1.45501 2.73072 2.32578 1.85996C3.19654 0.989191 4.37755 0.5 5.609 0.5H22.3244C23.5559 0.5 24.7369 0.989191 25.6077 1.85996C26.4784 2.73072 26.9676 3.91173 26.9676 5.14318V14.4295C26.9676 15.0393 26.8475 15.6431 26.6142 16.2064C26.3808 16.7697 26.0388 17.2816 25.6077 17.7128C25.1765 18.1439 24.6646 18.4859 24.1013 18.7193C23.538 18.9526 22.9342 19.0727 22.3244 19.0727H15.2445L9.5557 24.0502C9.29247 24.2803 8.96853 24.4297 8.62262 24.4806C8.27671 24.5315 7.92347 24.4817 7.60512 24.3371C7.28678 24.1925 7.01682 23.9593 6.82751 23.6654C6.63821 23.3714 6.53757 23.0292 6.53763 22.6795V19.0727H5.609C4.37755 19.0727 3.19654 18.5835 2.32578 17.7128C1.45501 16.842 0.96582 15.661 0.96582 14.4295V5.14318ZM5.609 2.35727C4.87013 2.35727 4.16152 2.65079 3.63907 3.17324C3.11661 3.6957 2.82309 4.40431 2.82309 5.14318V14.4295C2.82309 15.1684 3.11661 15.877 3.63907 16.3995C4.16152 16.9219 4.87013 17.2154 5.609 17.2154H8.39491V22.5978L14.5462 17.2154H22.3244C23.0633 17.2154 23.7719 16.9219 24.2944 16.3995C24.8168 15.877 25.1103 15.1684 25.1103 14.4295V5.14318C25.1103 4.40431 24.8168 3.6957 24.2944 3.17324C23.7719 2.65079 23.0633 2.35727 22.3244 2.35727H5.609Z"
      fill="#0D0D0D"
    />
  </svg>
);

export const LikeSvg = (
  <svg
    width="27"
    height="25"
    viewBox="0 0 27 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3191 24.3787C13.8607 24.5404 13.1056 24.5404 12.6472 24.3787C8.73708 23.0438 0 17.4753 0 8.03708C0 3.87079 3.3573 0.5 7.49663 0.5C9.95056 0.5 12.1213 1.68652 13.4831 3.52023C14.8449 1.68652 17.0292 0.5 19.4697 0.5C23.609 0.5 26.9663 3.87079 26.9663 8.03708C26.9663 17.4753 18.2292 23.0438 14.3191 24.3787Z"
      fill="#E72E2E"
    />
  </svg>
);

export const TagSvg = (
  <svg
    width="21"
    height="25"
    viewBox="0 0 21 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.417 12.5C13.4546 12.5 15.917 10.0376 15.917 7C15.917 3.96243 13.4546 1.5 10.417 1.5C7.37943 1.5 4.91699 3.96243 4.91699 7C4.91699 10.0376 7.37943 12.5 10.417 12.5Z"
      stroke="#292D32"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.8658 23.4998C19.8658 19.2428 15.6308 15.7998 10.4168 15.7998C5.20277 15.7998 0.967773 19.2428 0.967773 23.4998"
      stroke="#292D32"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const notLikedSvg = (
  <svg
    width="21"
    height="25"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.57769 14.9292C9.30308 15.0236 8.85077 15.0236 8.57615 14.9292C6.23385 14.1506 1 10.9022 1 5.39663C1 2.96629 3.01115 1 5.49077 1C6.96077 1 8.26115 1.69214 9.07692 2.7618C9.89269 1.69214 11.2012 1 12.6631 1C15.1427 1 17.1538 2.96629 17.1538 5.39663C17.1538 10.9022 11.92 14.1506 9.57769 14.9292Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const tickSvg = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.27117 1.42915C6.67367 1.08498 7.33284 1.08498 7.74117 1.42915L8.66284 2.22248C8.83784 2.37415 9.16451 2.49665 9.39784 2.49665H10.3895C11.0078 2.49665 11.5153 3.00415 11.5153 3.62248V4.61415C11.5153 4.84165 11.6378 5.17415 11.7895 5.34915L12.5828 6.27081C12.927 6.67331 12.927 7.33248 12.5828 7.74081L11.7895 8.66248C11.6378 8.83748 11.5153 9.16415 11.5153 9.39748V10.3891C11.5153 11.0075 11.0078 11.515 10.3895 11.515H9.39784C9.17034 11.515 8.83784 11.6375 8.66284 11.7891L7.74117 12.5825C7.33867 12.9266 6.6795 12.9266 6.27117 12.5825L5.3495 11.7891C5.17451 11.6375 4.84784 11.515 4.61451 11.515H3.60534C2.987 11.515 2.47951 11.0075 2.47951 10.3891V9.39165C2.47951 9.16415 2.35701 8.83748 2.21117 8.66248L1.42367 7.73498C1.08534 7.33248 1.08534 6.67915 1.42367 6.27665L2.21117 5.34915C2.35701 5.17415 2.47951 4.84748 2.47951 4.61998V3.61665C2.47951 2.99831 2.987 2.49081 3.60534 2.49081H4.61451C4.84201 2.49081 5.17451 2.36831 5.3495 2.21665L6.27117 1.42915Z"
      fill="#0D0D0D"
    />
    <path
      d="M4.88867 7.00005L6.29451 8.41171L9.11201 5.58838"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const HostEyeSvg = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#F5F5F5" />
    <path
      d="M18.3866 15.9999C18.3866 17.3199 17.3199 18.3866 15.9999 18.3866C14.6799 18.3866 13.6133 17.3199 13.6133 15.9999C13.6133 14.6799 14.6799 13.6133 15.9999 13.6133C17.3199 13.6133 18.3866 14.6799 18.3866 15.9999Z"
      stroke="#0D0D0D"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.9999 21.5133C18.3532 21.5133 20.5466 20.1266 22.0732 17.7266C22.6732 16.7866 22.6732 15.2066 22.0732 14.2666C20.5466 11.8666 18.3532 10.48 15.9999 10.48C13.6466 10.48 11.4532 11.8666 9.92656 14.2666C9.32656 15.2066 9.32656 16.7866 9.92656 17.7266C11.4532 20.1266 13.6466 21.5133 15.9999 21.5133Z"
      stroke="#0D0D0D"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const fileTag = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 13.01H12"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 9.01001H12"
      stroke="#292D32"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.99609 13H6.00508"
      stroke="#292D32"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.99609 9H6.00508"
      stroke="#292D32"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const moderationUsers = (
  <svg
    width="60"
    height="40"
    viewBox="0 0 60 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="60" height="48" rx="4" fill="#F5F5F5" />
    <path
      d="M27.6696 23.7634C27.6442 23.7634 27.6273 23.7634 27.602 23.7634C27.5597 23.7549 27.5006 23.7549 27.4499 23.7634C24.9991 23.6873 23.1484 21.7606 23.1484 19.3859C23.1484 16.969 25.1175 15 27.5344 15C29.9513 15 31.9203 16.969 31.9203 19.3859C31.9118 21.7606 30.0527 23.6873 27.6949 23.7634C27.6865 23.7634 27.678 23.7634 27.6696 23.7634ZM27.5344 16.2676C25.8189 16.2676 24.416 17.6704 24.416 19.3859C24.416 21.0761 25.7344 22.4366 27.416 22.4958C27.4668 22.4873 27.5766 22.4873 27.6865 22.4958C29.3428 22.4197 30.6442 21.0592 30.6527 19.3859C30.6527 17.6704 29.2499 16.2676 27.5344 16.2676Z"
      fill="#0D0D0D"
      stroke="#0D0D0D"
      stroke-width="0.3"
    />
    <path
      d="M33.9046 23.8733C33.8793 23.8733 33.8539 23.8733 33.8286 23.8648C33.4821 23.8986 33.1272 23.6536 33.0934 23.3071C33.0596 22.9606 33.2708 22.6479 33.6173 22.6057C33.7187 22.5972 33.8286 22.5972 33.9215 22.5972C35.1554 22.5296 36.1187 21.5155 36.1187 20.2733C36.1187 18.9888 35.0793 17.9493 33.7948 17.9493C33.4483 17.9578 33.161 17.6705 33.161 17.324C33.161 16.9775 33.4483 16.6902 33.7948 16.6902C35.7723 16.6902 37.3863 18.3043 37.3863 20.2817C37.3863 22.2254 35.8652 23.7972 33.93 23.8733C33.9215 23.8733 33.9131 23.8733 33.9046 23.8733Z"
      fill="#0D0D0D"
      stroke="#0D0D0D"
      stroke-width="0.3"
    />
    <path
      d="M27.6784 33C26.0221 33 24.3573 32.5775 23.0982 31.7324C21.9235 30.9549 21.2812 29.8901 21.2812 28.7324C21.2812 27.5746 21.9235 26.5014 23.0982 25.7155C25.6334 24.0338 29.7404 24.0338 32.2587 25.7155C33.4249 26.493 34.0756 27.5577 34.0756 28.7155C34.0756 29.8732 33.4334 30.9465 32.2587 31.7324C30.9911 32.5775 29.3348 33 27.6784 33ZM23.7996 26.7803C22.9883 27.3211 22.5489 28.0141 22.5489 28.7408C22.5489 29.4592 22.9967 30.1521 23.7996 30.6845C25.9038 32.0958 29.4531 32.0958 31.5573 30.6845C32.3686 30.1437 32.808 29.4507 32.808 28.7239C32.808 28.0056 32.3601 27.3127 31.5573 26.7803C29.4531 25.3775 25.9038 25.3775 23.7996 26.7803Z"
      fill="#0D0D0D"
      stroke="#0D0D0D"
      stroke-width="0.3"
    />
    <path
      d="M35.426 31.4789C35.1302 31.4789 34.8683 31.2761 34.8091 30.9719C34.7415 30.6254 34.9612 30.2958 35.2992 30.2198C35.8316 30.1099 36.3218 29.8986 36.7021 29.6029C37.1837 29.2395 37.4457 28.7832 37.4457 28.3015C37.4457 27.8198 37.1837 27.3634 36.7105 27.0085C36.3387 26.7212 35.8739 26.5184 35.3246 26.3916C34.9866 26.3155 34.7668 25.9775 34.8429 25.631C34.919 25.293 35.257 25.0733 35.6035 25.1493C36.3302 25.3099 36.964 25.5972 37.4795 25.9944C38.2654 26.586 38.7133 27.4226 38.7133 28.3015C38.7133 29.1803 38.257 30.017 37.4711 30.617C36.9471 31.0226 36.288 31.3184 35.5612 31.462C35.5105 31.4789 35.4683 31.4789 35.426 31.4789Z"
      fill="#0D0D0D"
      stroke="#0D0D0D"
      stroke-width="0.3"
    />
  </svg>
);

export const DummyUserProfile = ({ size }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#EFF0F6" />
    <path
      d="M23.751 14C23.751 14.9946 23.3559 15.9484 22.6526 16.6517C21.9493 17.3549 20.9955 17.75 20.001 17.75C19.0064 17.75 18.0526 17.3549 17.3493 16.6517C16.646 15.9484 16.251 14.9946 16.251 14C16.251 13.0054 16.646 12.0516 17.3493 11.3483C18.0526 10.6451 19.0064 10.25 20.001 10.25C20.9955 10.25 21.9493 10.6451 22.6526 11.3483C23.3559 12.0516 23.751 13.0054 23.751 14ZM12.502 28.118C12.5341 26.1504 13.3383 24.2742 14.7411 22.894C16.144 21.5139 18.033 20.7405 20.001 20.7405C21.9689 20.7405 23.8579 21.5139 25.2608 22.894C26.6636 24.2742 27.4678 26.1504 27.5 28.118C25.1473 29.1968 22.5891 29.7535 20.001 29.75C17.325 29.75 14.785 29.166 12.502 28.118Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const TotalProjects = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      d="M23.9971 36H29.997M23.9971 28.5H35.997"
      stroke="#1E3A8A"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M23.25 17.25C20.9163 17.32 19.5249 17.5798 18.5622 18.5434C17.2441 19.8627 17.2441 21.986 17.2441 26.2325V35.9916C17.2441 40.2383 17.2441 42.3615 18.5622 43.6808C19.8802 45 22.0015 45 26.2441 45H33.7442C37.9868 45 40.1081 45 41.4261 43.6808C42.7442 42.3615 42.7442 40.2383 42.7442 35.9916V26.2325C42.7442 21.986 42.7442 19.8627 41.4261 18.5434C40.4634 17.5798 39.072 17.32 36.7383 17.25"
      stroke="#1E3A8A"
      stroke-width="2.5"
    />
    <path
      d="M23.2441 17.625C23.2441 16.1753 24.4194 15 25.8691 15H34.1192C35.5689 15 36.7442 16.1753 36.7442 17.625C36.7442 19.0747 35.5689 20.25 34.1192 20.25H25.8691C24.4194 20.25 23.2441 19.0747 23.2441 17.625Z"
      stroke="#1E3A8A"
      stroke-width="2.5"
      stroke-linejoin="round"
    />
  </svg>
);

export const ActiveProjects = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      d="M41.25 31.5V26.0526C41.25 20.8424 41.25 18.2372 39.7123 16.6186C38.1745 15 35.6997 15 30.75 15H26.25C21.3003 15 18.8254 15 17.2877 16.6186C15.75 18.2372 15.75 20.8424 15.75 26.0526V33.9474C15.75 39.1577 15.75 41.7627 17.2877 43.3814C18.8254 45 21.3003 45 26.25 45H28.5"
      stroke="#1E3A8A"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.25 42C32.25 42 33.75 42 35.25 45C35.25 45 40.0148 37.5 44.25 36"
      stroke="#1E3A8A"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.5 15L22.6233 15.7398C22.9226 17.5357 23.0723 18.4336 23.7017 18.9668C24.3311 19.5 25.2414 19.5 27.0621 19.5H29.9379C31.7586 19.5 32.669 19.5 33.2984 18.9668C33.9278 18.4336 34.0774 17.5357 34.3767 15.7398L34.5 15"
      stroke="#1E3A8A"
      stroke-width="2.5"
      stroke-linejoin="round"
    />
    <path
      d="M22.5 36H28.5M22.5 28.5H34.5"
      stroke="#1E3A8A"
      stroke-width="2.5"
      stroke-linecap="round"
    />
  </svg>
);

export const TotalWorkers = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.6993 45H19.6992C18.0417 45 16.6992 43.6575 16.6992 42V36.3737C16.6992 35.1325 17.463 34.0187 18.6217 33.5737L23.9379 31.5287C23.7816 31.0388 23.6991 30.5237 23.6991 30V26.9362C23.3566 26.8475 23.0404 26.6687 22.7854 26.4138C22.4104 26.0387 22.1991 25.53 22.1991 25V23.5C22.1991 22.97 22.4104 22.4612 22.7854 22.0862C22.9391 21.9312 23.1166 21.805 23.3091 21.7087C23.7866 19.3974 25.4766 17.4725 27.7466 16.5637C27.9466 15.6687 28.7441 15 29.6991 15H31.6991C32.6541 15 33.4516 15.6687 33.6516 16.5637C35.9216 17.4725 37.6116 19.3975 38.0891 21.7087C38.2816 21.805 38.459 21.9312 38.6128 22.0862C38.9878 22.4612 39.199 22.97 39.199 23.5V25C39.199 25.53 38.9878 26.0387 38.6128 26.4138C38.3578 26.6688 38.0415 26.8475 37.699 26.9362V30C37.699 30.5237 37.6165 31.0388 37.4603 31.5287L42.7765 33.5737C43.9352 34.0187 44.699 35.1325 44.699 36.3737V42C44.699 43.6575 43.3568 45 41.6993 45ZM25.6992 27V30C25.6992 30.2762 25.7367 30.5475 25.8105 30.8087C25.948 31.3012 26.2105 31.7537 26.578 32.1212C26.7142 32.2575 26.863 32.38 27.0205 32.4862C27.0792 32.5262 27.138 32.5625 27.1992 32.5975C27.6517 32.8587 28.168 33 28.6992 33H32.6992C33.2305 33 33.7467 32.8587 34.1992 32.5975C34.2605 32.5625 34.3192 32.5262 34.378 32.4862C34.5355 32.38 34.6842 32.2575 34.8205 32.1212C35.188 31.7537 35.4505 31.3012 35.588 30.8087C35.6617 30.5475 35.6992 30.2762 35.6992 30V27H25.6992ZM25.1992 33.5712C25.1867 33.5587 25.1755 33.5474 25.163 33.5362C25.0842 33.4562 25.0067 33.3737 24.933 33.2887L22.6992 34.1474V42.9999H29.6992V38.975C28.5567 38.86 27.483 38.355 26.663 37.5362C25.7267 36.5974 25.1992 35.3262 25.1992 33.9999L25.1992 33.5712ZM20.6994 34.9174L19.3406 35.4399C18.9544 35.5887 18.6994 35.9599 18.6994 36.3737V41.9999C18.6994 42.5524 19.1469 42.9999 19.6994 42.9999H20.6994V34.9174ZM24.1996 25H37.1996V23.5H24.1996V25ZM40.6994 43H41.6994C42.2519 43 42.6994 42.5525 42.6994 42V36.3737C42.6994 35.96 42.4444 35.5887 42.0582 35.44L40.6994 34.9175V43ZM38.6994 34.1475L36.4657 33.2887C36.3919 33.3737 36.3144 33.4562 36.2357 33.5362C36.2232 33.5475 36.2119 33.5587 36.1994 33.5712V34C36.1994 35.3262 35.6719 36.5975 34.7357 37.5363C33.9157 38.3551 32.8419 38.8601 31.6994 38.9751V43H38.6994L38.6994 34.1475ZM34.0908 34.8025C33.642 34.9325 33.1745 35 32.6995 35H28.6995C28.2245 35 27.757 34.9325 27.3082 34.8025C27.447 35.2975 27.7095 35.7525 28.0782 36.1213C28.6407 36.6838 29.4032 37 30.1995 37H31.1995C31.9957 37 32.7582 36.6838 33.3207 36.1213C33.6895 35.7525 33.9521 35.2975 34.0908 34.8025ZM35.962 21.5001C35.567 20.3776 34.7558 19.4326 33.6995 18.8076V21.5001H35.962ZM27.6996 18.8076C26.6434 19.4326 25.8321 20.3775 25.4371 21.5001H27.6996V18.8076ZM31.6996 21.5001V17.0002H29.6996V21.5001H31.6996Z"
      fill="#1E3A8A"
    />
  </svg>
);

export const TotalOrganizations = (
  <svg
    width="80"
    height="80"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      d="M40 45.5H20C19.0335 45.5 18.25 44.7165 18.25 43.75V22.5C18.25 21.5335 19.0335 20.75 20 20.75H25V16.5C25 15.5335 25.7835 14.75 26.75 14.75H33.25C34.2165 14.75 35 15.5335 35 16.5V20.75H40C40.9665 20.75 41.75 21.5335 41.75 22.5V43.75C41.75 44.7165 40.9665 45.5 40 45.5Z"
      stroke="#1E3A8A"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 20.75V45.5M35 20.75V45.5"
      stroke="#1E3A8A"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M30 28H30.025M30 37H30.025"
      stroke="#1E3A8A"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M23 28H23.025M23 37H23.025"
      stroke="#1E3A8A"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M37 28H37.025M37 37H37.025"
      stroke="#1E3A8A"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const TotalManagers = (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="30" cy="30" r="28" fill="#EEF0F6"/>
  <g transform="translate(13.2, 13.2) scale(1.4)">
    <path d="M20 22V17C20 15.1 20 14.17 19.41 13.59C18.83 13 17.89 13 16 13L12 22L8 13C6.11 13 5.17 13 4.59 13.59C4 14.17 4 15.1 4 17V22" 
      stroke="#1E3A8A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  
    <path d="M12 15L11.5 19L12 20.5L12.5 19L12 15ZM12 15L11 13H13L12 15Z" 
      stroke="#1E3A8A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    
    <path d="M15.5 6.5V5.5C15.5 3.57 13.93 2 12 2C10.07 2 8.5 3.57 8.5 5.5V6.5C8.5 8.43 10.07 10 12 10C13.93 10 15.5 8.43 15.5 6.5Z" 
      stroke="#1E3A8A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
</svg>

);

// Manager icon for sidebar (24x24)
export const ManagerIconSidebar = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11" fill="#EEF0F6"/>
    <g transform="translate(2.4, 2.4) scale(0.8)">
      <path d="M20 22V17C20 15.1 20 14.17 19.41 13.59C18.83 13 17.89 13 16 13L12 22L8 13C6.11 13 5.17 13 4.59 13.59C4 14.17 4 15.1 4 17V22" 
        stroke="#1E3A8A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 15L11.5 19L12 20.5L12.5 19L12 15ZM12 15L11 13H13L12 15Z" 
        stroke="#1E3A8A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.5 6.5V5.5C15.5 3.57 13.93 2 12 2C10.07 2 8.5 3.57 8.5 5.5V6.5C8.5 8.43 10.07 10 12 10C13.93 10 15.5 8.43 15.5 6.5Z" 
        stroke="#1E3A8A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
);

export const FilterButton = (
  <svg
    width="80"
    height="32"
    viewBox="0 0 80 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="79" height="31" rx="3.5" fill="white" />
    <rect x="0.5" y="0.5" width="79" height="31" rx="3.5" stroke="#1E3A8A" />
    <path
      d="M19 12H25.5M19 12C19 12.2652 18.8946 12.5196 18.7071 12.7071C18.5196 12.8946 18.2652 13 18 13C17.7348 13 17.4804 12.8946 17.2929 12.7071C17.1054 12.5196 17 12.2652 17 12M19 12C19 11.7348 18.8946 11.4804 18.7071 11.2929C18.5196 11.1054 18.2652 11 18 11C17.7348 11 17.4804 11.1054 17.2929 11.2929C17.1054 11.4804 17 11.7348 17 12M17 12H14.5M19 20H25.5M19 20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21C17.7348 21 17.4804 20.8946 17.2929 20.7071C17.1054 20.5196 17 20.2652 17 20M19 20C19 19.7348 18.8946 19.4804 18.7071 19.2929C18.5196 19.1054 18.2652 19 18 19C17.7348 19 17.4804 19.1054 17.2929 19.2929C17.1054 19.4804 17 19.7348 17 20M17 20H14.5M23 16H25.5M23 16C23 16.2652 22.8946 16.5196 22.7071 16.7071C22.5196 16.8946 22.2652 17 22 17C21.7348 17 21.4804 16.8946 21.2929 16.7071C21.1054 16.5196 21 16.2652 21 16M23 16C23 15.7348 22.8946 15.4804 22.7071 15.2929C22.5196 15.1054 22.2652 15 22 15C21.7348 15 21.4804 15.1054 21.2929 15.2929C21.1054 15.4804 21 15.7348 21 16M21 16H14.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.292 11.965V13.174H34.457V15.839H37.447V17.048H34.457V21H32.975V11.965H38.292ZM40.4194 12.888C40.1508 12.888 39.9254 12.797 39.7434 12.615C39.5614 12.433 39.4704 12.2077 39.4704 11.939C39.4704 11.6703 39.5614 11.445 39.7434 11.263C39.9254 11.081 40.1508 10.99 40.4194 10.99C40.6794 10.99 40.9004 11.081 41.0824 11.263C41.2644 11.445 41.3554 11.6703 41.3554 11.939C41.3554 12.2077 41.2644 12.433 41.0824 12.615C40.9004 12.797 40.6794 12.888 40.4194 12.888ZM41.1474 13.837V21H39.6654V13.837H41.1474ZM44.5752 11.38V21H43.0932V11.38H44.5752ZM48.2499 15.046V19.011C48.2499 19.2797 48.3106 19.4747 48.4319 19.596C48.5619 19.7087 48.7786 19.765 49.0819 19.765H49.9919V21H48.8219C48.1546 21 47.6432 20.844 47.2879 20.532C46.9326 20.22 46.7549 19.713 46.7549 19.011V15.046H45.9099V13.837H46.7549V12.056H48.2499V13.837H49.9919V15.046H48.2499ZM57.9228 17.243C57.9228 17.5117 57.9055 17.7543 57.8708 17.971H52.3978C52.4411 18.543 52.6535 19.0023 53.0348 19.349C53.4161 19.6957 53.8841 19.869 54.4388 19.869C55.2361 19.869 55.7995 19.5353 56.1288 18.868H57.7278C57.5111 19.5267 57.1168 20.0683 56.5448 20.493C55.9815 20.909 55.2795 21.117 54.4388 21.117C53.7541 21.117 53.1388 20.9653 52.5928 20.662C52.0555 20.35 51.6308 19.9167 51.3188 19.362C51.0155 18.7987 50.8638 18.1487 50.8638 17.412C50.8638 16.6753 51.0111 16.0297 51.3058 15.475C51.6091 14.9117 52.0295 14.4783 52.5668 14.175C53.1128 13.8717 53.7368 13.72 54.4388 13.72C55.1148 13.72 55.7171 13.8673 56.2458 14.162C56.7745 14.4567 57.1861 14.8727 57.4808 15.41C57.7755 15.9387 57.9228 16.5497 57.9228 17.243ZM56.3758 16.775C56.3671 16.229 56.1721 15.7913 55.7908 15.462C55.4095 15.1327 54.9371 14.968 54.3738 14.968C53.8625 14.968 53.4248 15.1327 53.0608 15.462C52.6968 15.7827 52.4801 16.2203 52.4108 16.775H56.3758ZM60.8633 14.877C61.0799 14.513 61.3659 14.2313 61.7213 14.032C62.0853 13.824 62.5143 13.72 63.0083 13.72V15.254H62.6313C62.0506 15.254 61.6086 15.4013 61.3053 15.696C61.0106 15.9907 60.8633 16.502 60.8633 17.23V21H59.3813V13.837H60.8633V14.877Z"
      fill="#1E3A8A"
    />
  </svg>
);
export const DateCalendar = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.75 1V3.25M15.25 1V3.25M1 16.75V5.5C1 4.90326 1.23705 4.33097 1.65901 3.90901C2.08097 3.48705 2.65326 3.25 3.25 3.25H16.75C17.3467 3.25 17.919 3.48705 18.341 3.90901C18.7629 4.33097 19 4.90326 19 5.5V16.75M1 16.75C1 17.3467 1.23705 17.919 1.65901 18.341C2.08097 18.7629 2.65326 19 3.25 19H16.75C17.3467 19 17.919 18.7629 18.341 18.341C18.7629 17.919 19 17.3467 19 16.75M1 16.75V9.25C1 8.65326 1.23705 8.08097 1.65901 7.65901C2.08097 7.23705 2.65326 7 3.25 7H16.75C17.3467 7 17.919 7.23705 18.341 7.65901C18.7629 8.08097 19 8.65326 19 9.25V16.75M10 10.75H10.008V10.758H10V10.75ZM10 13H10.008V13.008H10V13ZM10 15.25H10.008V15.258H10V15.25ZM7.75 13H7.758V13.008H7.75V13ZM7.75 15.25H7.758V15.258H7.75V15.25ZM5.5 13H5.508V13.008H5.5V13ZM5.5 15.25H5.508V15.258H5.5V15.25ZM12.25 10.75H12.258V10.758H12.25V10.75ZM12.25 13H12.258V13.008H12.25V13ZM12.25 15.25H12.258V15.258H12.25V15.25ZM14.5 10.75H14.508V10.758H14.5V10.75ZM14.5 13H14.508V13.008H14.5V13Z"
      stroke="#4B5563"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DropDown = (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.5L6 6.5L1 1.5"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Logout = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="31" height="31" rx="15.5" fill="#F6F6F6" />
      <path
        d="M22.324 15.924L19.924 18.324C19.8072 18.4408 19.6536 18.5 19.5 18.5C19.3464 18.5 19.1928 18.4416 19.076 18.324C18.8416 18.0896 18.8416 17.7096 19.076 17.4752L20.452 16.0992H13.1008C12.7696 16.0992 12.5008 15.8304 12.5008 15.4992C12.5008 15.168 12.7696 14.8992 13.1008 14.8992L20.452 14.8992L19.076 13.5232C18.8416 13.2888 18.8416 12.9088 19.076 12.6744C19.3104 12.44 19.6904 12.44 19.9248 12.6744L22.3248 15.0744C22.5592 15.3088 22.5592 15.6888 22.3248 15.9232L22.324 15.924ZM13.7 21.9C13.7 21.5688 13.4312 21.3 13.1 21.3H10.7C10.1488 21.3 9.7 20.8512 9.7 20.3L9.7 10.7C9.7 10.1488 10.1488 9.7 10.7 9.7H13.1C13.4312 9.7 13.7 9.4312 13.7 9.1C13.7 8.7688 13.4312 8.5 13.1 8.5H10.7C9.4864 8.5 8.5 9.4864 8.5 10.7L8.5 20.3C8.5 21.5136 9.4864 22.5 10.7 22.5H13.1C13.4312 22.5 13.7 22.2312 13.7 21.9Z"
        fill="#EE1B24"
      />
    </svg>
  );
};

export const ActionEye = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.69743 10.2683C1.63992 10.0955 1.63992 9.90867 1.69743 9.73583C2.85326 6.25833 6.1341 3.75 10.0008 3.75C13.8658 3.75 17.1449 6.25583 18.3033 9.73167C18.3616 9.90417 18.3616 10.0908 18.3033 10.2642C17.1483 13.7417 13.8674 16.25 10.0008 16.25C6.13576 16.25 2.85576 13.7442 1.69743 10.2683Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 10C7.5 9.33696 7.76339 8.70107 8.23223 8.23223C8.70107 7.76339 9.33696 7.5 10 7.5C10.663 7.5 11.2989 7.76339 11.7678 8.23223C12.2366 8.70107 12.5 9.33696 12.5 10Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ActionSend = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00044 10.4993L2.72461 3.10352C8.16867 4.68685 13.3024 7.18806 17.9046 10.4993C13.3027 13.8106 8.16921 16.3118 2.72544 17.8952L5.00044 10.4993ZM5.00044 10.4993H11.2504"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const EditPencil = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const EditPencilComment = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
      stroke="#B7B7B7"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const DeleteBin = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2833 7.50043L11.995 15.0004M8.005 15.0004L7.71667 7.50043M16.0233 4.82543C16.3083 4.86877 16.5917 4.9146 16.875 4.96377M16.0233 4.82543L15.1333 16.3946C15.097 16.8656 14.8842 17.3056 14.5375 17.6265C14.1908 17.9474 13.7358 18.1256 13.2633 18.1254H6.73667C6.26425 18.1256 5.80919 17.9474 5.46248 17.6265C5.11578 17.3056 4.90299 16.8656 4.86667 16.3946L3.97667 4.82543M16.0233 4.82543C15.0616 4.68003 14.0948 4.56968 13.125 4.4946M3.97667 4.82543C3.69167 4.86793 3.40833 4.91377 3.125 4.96293M3.97667 4.82543C4.93844 4.68003 5.9052 4.56968 6.875 4.4946M13.125 4.4946V3.73127C13.125 2.74793 12.3667 1.92793 11.3833 1.8971C10.4613 1.86763 9.53865 1.86763 8.61667 1.8971C7.63333 1.92793 6.875 2.74877 6.875 3.73127V4.4946M13.125 4.4946C11.0448 4.33383 8.95523 4.33383 6.875 4.4946"
      stroke="#E90C0C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const DeleteBinComment = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2833 7.50043L11.995 15.0004M8.005 15.0004L7.71667 7.50043M16.0233 4.82543C16.3083 4.86877 16.5917 4.9146 16.875 4.96377M16.0233 4.82543L15.1333 16.3946C15.097 16.8656 14.8842 17.3056 14.5375 17.6265C14.1908 17.9474 13.7358 18.1256 13.2633 18.1254H6.73667C6.26425 18.1256 5.80919 17.9474 5.46248 17.6265C5.11578 17.3056 4.90299 16.8656 4.86667 16.3946L3.97667 4.82543M16.0233 4.82543C15.0616 4.68003 14.0948 4.56968 13.125 4.4946M3.97667 4.82543C3.69167 4.86793 3.40833 4.91377 3.125 4.96293M3.97667 4.82543C4.93844 4.68003 5.9052 4.56968 6.875 4.4946M13.125 4.4946V3.73127C13.125 2.74793 12.3667 1.92793 11.3833 1.8971C10.4613 1.86763 9.53865 1.86763 8.61667 1.8971C7.63333 1.92793 6.875 2.74877 6.875 3.73127V4.4946M13.125 4.4946C11.0448 4.33383 8.95523 4.33383 6.875 4.4946"
      stroke="#E90C0C"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const filterIcon = (
  <svg
    width="84"
    height="84"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_372_13389)">
      <path
        d="M20.5 20C20.5 18.067 22.067 16.5 24 16.5H60C61.933 16.5 63.5 18.067 63.5 20V56C63.5 57.933 61.933 59.5 60 59.5H24C22.067 59.5 20.5 57.933 20.5 56V20Z"
        stroke="#E9E9E9"
        shape-rendering="crispEdges"
      />
    </g>
    <path
      d="M42 29C44.755 29 47.455 29.232 50.083 29.678C50.616 29.768 51 30.234 51 30.774V31.818C51 32.1135 50.9418 32.4061 50.8287 32.679C50.7157 32.952 50.5499 33.2001 50.341 33.409L44.909 38.841C44.7001 39.0499 44.5343 39.298 44.4213 39.571C44.3082 39.8439 44.25 40.1365 44.25 40.432V43.359C44.2501 43.777 44.1337 44.1867 43.914 44.5423C43.6943 44.8978 43.3799 45.1851 43.006 45.372L39.75 47V40.432C39.75 40.1365 39.6918 39.8439 39.5787 39.571C39.4657 39.298 39.2999 39.0499 39.091 38.841L33.659 33.409C33.4501 33.2001 33.2843 32.952 33.1713 32.679C33.0582 32.4061 33 32.1135 33 31.818V30.774C33 30.234 33.384 29.768 33.917 29.678C36.5876 29.2259 39.2914 28.9991 42 29Z"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_372_13389"
        x="0"
        y="0"
        width="84"
        height="84"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_372_13389"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_372_13389"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const LikeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5275 8.54102C5.19917 8.54102 5.805 8.16935 6.22 7.64102C6.86688 6.8157 7.67893 6.1345 8.60417 5.64102C9.20667 5.32102 9.72917 4.84435 9.98167 4.21185C10.159 3.76872 10.2501 3.29581 10.25 2.81852V2.29102C10.25 2.12526 10.3159 1.96628 10.4331 1.84907C10.5503 1.73186 10.7092 1.66602 10.875 1.66602C11.3723 1.66602 11.8492 1.86356 12.2008 2.21519C12.5525 2.56682 12.75 3.04373 12.75 3.54102C12.75 4.50102 12.5333 5.41018 12.1475 6.22268C11.9258 6.68768 12.2367 7.29102 12.7517 7.29102M12.7517 7.29102H15.3567C16.2117 7.29102 16.9775 7.86935 17.0683 8.72018C17.1058 9.07185 17.125 9.42852 17.125 9.79102C17.1284 12.0713 16.3492 14.2837 14.9175 16.0585C14.5942 16.4602 14.095 16.666 13.58 16.666H10.2333C9.83084 16.666 9.43 16.601 9.0475 16.4743L6.4525 15.6077C6.07009 15.4805 5.66968 15.4158 5.26667 15.416H3.92M12.7517 7.29102H10.875M3.92 15.416C3.98917 15.5868 4.06417 15.7535 4.145 15.9177C4.30917 16.251 4.08 16.666 3.70917 16.666H2.9525C2.21167 16.666 1.525 16.2343 1.30917 15.526C1.02054 14.5787 0.874221 13.5938 0.875003 12.6035C0.875003 11.3093 1.12084 10.0735 1.5675 8.93852C1.8225 8.29352 2.4725 7.91602 3.16667 7.91602H4.04417C4.4375 7.91602 4.665 8.37935 4.46084 8.71602C3.74908 9.88764 3.37369 11.2326 3.37584 12.6035C3.37584 13.5985 3.56917 14.5477 3.92084 15.416H3.92Z"
      stroke="#B7B7B7"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const LikedIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5275 8.54102C5.19917 8.54102 5.805 8.16935 6.22 7.64102C6.86688 6.8157 7.67893 6.1345 8.60417 5.64102C9.20667 5.32102 9.72917 4.84435 9.98167 4.21185C10.159 3.76872 10.2501 3.29581 10.25 2.81852V2.29102C10.25 2.12526 10.3159 1.96628 10.4331 1.84907C10.5503 1.73186 10.7092 1.66602 10.875 1.66602C11.3723 1.66602 11.8492 1.86356 12.2008 2.21519C12.5525 2.56682 12.75 3.04373 12.75 3.54102C12.75 4.50102 12.5333 5.41018 12.1475 6.22268C11.9258 6.68768 12.2367 7.29102 12.7517 7.29102M12.7517 7.29102H15.3567C16.2117 7.29102 16.9775 7.86935 17.0683 8.72018C17.1058 9.07185 17.125 9.42852 17.125 9.79102C17.1284 12.0713 16.3492 14.2837 14.9175 16.0585C14.5942 16.4602 14.095 16.666 13.58 16.666H10.2333C9.83084 16.666 9.43 16.601 9.0475 16.4743L6.4525 15.6077C6.07009 15.4805 5.66968 15.4158 5.26667 15.416H3.92M12.7517 7.29102H10.875M3.92 15.416C3.98917 15.5868 4.06417 15.7535 4.145 15.9177C4.30917 16.251 4.08 16.666 3.70917 16.666H2.9525C2.21167 16.666 1.525 16.2343 1.30917 15.526C1.02054 14.5787 0.874221 13.5938 0.875003 12.6035C0.875003 11.3093 1.12084 10.0735 1.5675 8.93852C1.8225 8.29352 2.4725 7.91602 3.16667 7.91602H4.04417C4.4375 7.91602 4.665 8.37935 4.46084 8.71602C3.74908 9.88764 3.37369 11.2326 3.37584 12.6035C3.37584 13.5985 3.56917 14.5477 3.92084 15.416H3.92Z"
      fill="none"
      stroke="black"
      strokeWidth="1"
    />
  </svg>
);





export const ReplyIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 6.5L16.5 11.5M16.5 11.5L11.5 16.5M16.5 11.5H6.5C5.17392 11.5 3.90215 10.9732 2.96447 10.0355C2.02678 9.09785 1.5 7.82608 1.5 6.5C1.5 5.17392 2.02678 3.90215 2.96447 2.96447C3.90215 2.02678 5.17392 1.5 6.5 1.5H9"
      stroke="#B7B7B7"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CommentIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 4.125H8.25M3.75 5.625H6M1.125 6.38C1.125 7.18 1.6865 7.877 2.4785 7.9935C3.043 8.0765 3.6135 8.14 4.19 8.183C4.365 8.196 4.525 8.288 4.6225 8.4335L6 10.5L7.3775 8.4335C7.42582 8.36163 7.48989 8.30172 7.56483 8.25832C7.63977 8.21491 7.72362 8.18916 7.81 8.183C8.38258 8.14025 8.95344 8.07705 9.5215 7.9935C10.3135 7.877 10.875 7.1805 10.875 6.3795V3.3705C10.875 2.5695 10.3135 1.873 9.5215 1.7565C8.35548 1.58536 7.17851 1.49963 6 1.5C4.804 1.5 3.628 1.5875 2.4785 1.7565C1.6865 1.873 1.125 2.57 1.125 3.3705V6.3795V6.38Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const CommentIconLarge = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 4.125H8.25M3.75 5.625H6M1.125 6.38C1.125 7.18 1.6865 7.877 2.4785 7.9935C3.043 8.0765 3.6135 8.14 4.19 8.183C4.365 8.196 4.525 8.288 4.6225 8.4335L6 10.5L7.3775 8.4335C7.42582 8.36163 7.48989 8.30172 7.56483 8.25832C7.63977 8.21491 7.72362 8.18916 7.81 8.183C8.38258 8.14025 8.95344 8.07705 9.5215 7.9935C10.3135 7.877 10.875 7.1805 10.875 6.3795V3.3705C10.875 2.5695 10.3135 1.873 9.5215 1.7565C8.35548 1.58536 7.17851 1.49963 6 1.5C4.804 1.5 3.628 1.5875 2.4785 1.7565C1.6865 1.873 1.125 2.57 1.125 3.3705V6.3795V6.38Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LocationIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 8.75C12.5 9.41304 12.2366 10.0489 11.7678 10.5178C11.2989 10.9866 10.663 11.25 10 11.25C9.33696 11.25 8.70107 10.9866 8.23223 10.5178C7.76339 10.0489 7.5 9.41304 7.5 8.75C7.5 8.08696 7.76339 7.45107 8.23223 6.98223C8.70107 6.51339 9.33696 6.25 10 6.25C10.663 6.25 11.2989 6.51339 11.7678 6.98223C12.2366 7.45107 12.5 8.08696 12.5 8.75Z"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.25 8.75C16.25 14.7017 10 18.125 10 18.125C10 18.125 3.75 14.7017 3.75 8.75C3.75 7.0924 4.40848 5.50268 5.58058 4.33058C6.75268 3.15848 8.3424 2.5 10 2.5C11.6576 2.5 13.2473 3.15848 14.4194 4.33058C15.5915 5.50268 16.25 7.0924 16.25 8.75Z"
      stroke="#4B5563"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LoginLogo = (
  <svg
    width="130"
    height="130"
    viewBox="0 0 84 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42 52C56.3594 52 68 40.3594 68 26C68 11.6406 56.3594 0 42 0C27.6406 0 16 11.6406 16 26C16 40.3594 27.6406 52 42 52ZM43.0807 49.8327C56.8418 49.8327 67.9974 39.1621 67.9974 25.9994C67.9974 12.8366 56.8418 2.16602 43.0807 2.16602C29.3196 2.16602 18.1641 12.8366 18.1641 25.9994C18.1641 39.1621 29.3196 49.8327 43.0807 49.8327Z"
      fill="#1E3A8A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.9935 47.6712C30.0273 47.6712 20.3268 37.9707 20.3268 26.0046C20.3268 14.0384 30.0273 4.33789 41.9935 4.33789C53.9597 4.33789 63.6602 14.0384 63.6602 26.0046C63.6602 37.9707 53.9597 47.6712 41.9935 47.6712ZM40.9128 45.5039C29.5449 45.5039 20.3294 36.7735 20.3294 26.0039C20.3294 15.2344 29.5449 6.50391 40.9128 6.50391C52.2806 6.50391 61.4961 15.2344 61.4961 26.0039C61.4961 36.7735 52.2806 45.5039 40.9128 45.5039Z"
      fill="#1E3A8A"
    />
    <circle
      cx="15.1667"
      cy="15.1667"
      r="15.1667"
      transform="matrix(-1 0 0 1 56.6836 10.8359)"
      fill="#B8C6F0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.3098 10.9289C47.3499 11.7687 52.8252 18.197 52.8252 26.0026C52.8252 33.8082 47.3499 40.2365 40.3098 41.0763C40.8642 41.1377 41.4276 41.1693 41.9984 41.1693C50.3747 41.1693 57.165 34.3789 57.165 26.0026C57.165 17.6263 50.3747 10.8359 41.9984 10.8359C41.4276 10.8359 40.8642 10.8675 40.3098 10.9289Z"
      fill="#1E3A8A"
    />
    <path
      d="M21.951 13.3443C21.0617 12.5436 20.9899 11.1736 21.7906 10.2844C22.5913 9.39512 23.9613 9.32333 24.8505 10.124L30.1622 14.9066L27.2626 18.1269L21.951 13.3443Z"
      fill="#F97316"
    />
    <path
      d="M59.3473 26.0072C59.3473 35.5801 51.5869 43.3405 42.014 43.3405C32.4411 43.3405 24.6807 35.5801 24.6807 26.0072C24.6807 16.4342 32.4411 8.67383 42.014 8.67383C51.5869 8.67383 59.3473 16.4342 59.3473 26.0072ZM27.1042 26.0072C27.1042 34.2416 33.7795 40.917 42.014 40.917C50.2485 40.917 56.9238 34.2416 56.9238 26.0072C56.9238 17.7727 50.2485 11.0973 42.014 11.0973C33.7795 11.0973 27.1042 17.7727 27.1042 26.0072Z"
      fill="#F97316"
    />
    <path
      d="M40.8172 17.3359C41.1616 18.1904 41.5008 19.0199 41.8314 19.853C41.9812 20.2302 41.8985 20.5681 41.6919 20.9095C41.5783 21.0972 41.4836 21.3368 41.4818 21.5549C41.4663 23.9057 41.4715 26.2582 41.4732 28.609C41.4732 29.2204 41.6316 29.3813 42.2102 29.3831C43.4138 29.3867 44.6191 29.3849 45.8226 29.3813C45.9638 29.3813 46.1412 29.3956 46.2376 29.317C46.6543 28.9827 47.0245 29.1239 47.436 29.3331C47.8028 29.5208 48.2057 29.6334 48.6551 29.8032C48.0301 30.0606 47.4584 30.3055 46.8781 30.5272C46.7834 30.563 46.656 30.5076 46.5441 30.4861C46.1446 30.411 45.7469 30.2805 45.3474 30.268C44.273 30.2376 43.1968 30.2448 42.1224 30.268C41.9158 30.2716 41.6833 30.3735 41.5146 30.5022C41.1392 30.7882 40.6158 30.8365 40.2817 30.563C39.9132 30.2591 39.8461 29.7442 40.0579 29.2669C40.1732 29.0095 40.2628 28.7109 40.2645 28.4321C40.2817 26.1706 40.2817 23.9074 40.2645 21.646C40.2628 21.3868 40.1595 21.1026 40.0303 20.8773C39.8289 20.5269 39.7841 20.1873 39.915 19.8137C40.1905 19.0199 40.4677 18.228 40.7483 17.4343C40.7656 17.386 40.8086 17.3467 40.8172 17.3359ZM41.3975 29.8318C41.4009 29.4975 41.1702 29.2383 40.8861 29.2419C40.5658 29.2472 40.3764 29.4296 40.3454 29.7585C40.3162 30.0624 40.5848 30.3556 40.8758 30.3342C41.1909 30.3109 41.3665 30.1196 41.3975 29.83V29.8318Z"
      fill="#1E3A8A"
    />
    <path
      d="M41.4019 29.8343C41.3709 30.1221 41.1953 30.3152 40.8802 30.3384C40.5892 30.3599 40.3206 30.0667 40.3498 29.7628C40.3808 29.4339 40.5702 29.2498 40.8905 29.2462C41.1746 29.2408 41.4053 29.5018 41.4019 29.8361V29.8343Z"
      fill="white"
    />
  </svg>
);

export const NavLogo = (
  <svg
    width="269"
    height="40"
    viewBox="0 0 269 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM20.8317 38.3346C31.4172 38.3346 39.9984 30.1265 39.9984 20.0013C39.9984 9.87608 31.4172 1.66797 20.8317 1.66797C10.2462 1.66797 1.66504 9.87608 1.66504 20.0013C1.66504 30.1265 10.2462 38.3346 20.8317 38.3346Z"
      fill="#1E3A8A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.9954 36.6693C10.7907 36.6693 3.32878 29.2073 3.32878 20.0026C3.32878 10.7979 10.7907 3.33594 19.9954 3.33594C29.2002 3.33594 36.6621 10.7979 36.6621 20.0026C36.6621 29.2073 29.2002 36.6693 19.9954 36.6693ZM19.1647 35.0039C10.4202 35.0039 3.33138 28.2882 3.33138 20.0039C3.33138 11.7196 10.4202 5.00391 19.1647 5.00391C27.9092 5.00391 34.998 11.7196 34.998 20.0039C34.998 28.2882 27.9092 35.0039 19.1647 35.0039Z"
      fill="#1E3A8A"
    />
    <circle
      cx="11.6667"
      cy="11.6667"
      r="11.6667"
      transform="matrix(-1 0 0 1 31.2939 8.33594)"
      fill="#B8C6F0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.6963 8.40746C24.1116 9.05358 28.3233 13.9984 28.3233 20.0026C28.3233 26.0068 24.1116 30.9516 18.6963 31.5978C19.1228 31.645 19.5563 31.6693 19.9954 31.6693C26.4388 31.6693 31.6621 26.4459 31.6621 20.0026C31.6621 13.5593 26.4388 8.33594 19.9954 8.33594C19.5563 8.33594 19.1228 8.3602 18.6963 8.40746Z"
      fill="#1E3A8A"
    />
    <path
      d="M4.57647 10.2695C3.89242 9.6536 3.83719 8.59977 4.45311 7.91572V7.91572C5.06903 7.23168 6.12286 7.17645 6.8069 7.79236L10.8928 11.4713L8.66235 13.9485L4.57647 10.2695Z"
      fill="#F97316"
    />
    <path
      d="M33.3434 20.0091C33.3434 27.3729 27.3739 33.3425 20.0101 33.3425C12.6463 33.3425 6.67676 27.3729 6.67676 20.0091C6.67676 12.6453 12.6463 6.67578 20.0101 6.67578C27.3739 6.67578 33.3434 12.6453 33.3434 20.0091ZM8.54098 20.0091C8.54098 26.3433 13.6759 31.4782 20.0101 31.4782C26.3443 31.4782 31.4792 26.3433 31.4792 20.0091C31.4792 13.6749 26.3443 8.54001 20.0101 8.54001C13.6759 8.54001 8.54098 13.6749 8.54098 20.0091Z"
      fill="#F97316"
    />
    <path
      d="M19.089 13.3398C19.3539 13.9972 19.6148 14.6352 19.8691 15.276C19.9843 15.5662 19.9207 15.8261 19.7618 16.0887C19.6744 16.2331 19.6015 16.4174 19.6002 16.5852C19.5883 18.3935 19.5923 20.2032 19.5936 22.0115C19.5936 22.4818 19.7155 22.6055 20.1605 22.6069C21.0863 22.6096 22.0135 22.6083 22.9393 22.6055C23.0479 22.6055 23.1843 22.6165 23.2585 22.556C23.579 22.2989 23.8638 22.4075 24.1803 22.5684C24.4625 22.7128 24.7724 22.7994 25.1181 22.9301C24.6373 23.1281 24.1976 23.3165 23.7512 23.487C23.6784 23.5145 23.5804 23.4719 23.4943 23.4554C23.187 23.3976 22.881 23.2972 22.5737 23.2876C21.7472 23.2642 20.9194 23.2697 20.0929 23.2876C19.934 23.2903 19.7552 23.3687 19.6254 23.4677C19.3366 23.6878 18.934 23.7249 18.677 23.5145C18.3936 23.2807 18.3419 22.8847 18.5049 22.5175C18.5936 22.3195 18.6625 22.0898 18.6638 21.8753C18.677 20.1358 18.677 18.3949 18.6638 16.6553C18.6625 16.4559 18.583 16.2373 18.4837 16.064C18.3287 15.7945 18.2943 15.5332 18.3949 15.2458C18.6068 14.6352 18.8201 14.026 19.036 13.4155C19.0492 13.3783 19.0823 13.3481 19.089 13.3398ZM19.5353 22.9521C19.538 22.6949 19.3605 22.4955 19.1419 22.4983C18.8956 22.5024 18.7499 22.6427 18.726 22.8957C18.7035 23.1294 18.9102 23.355 19.134 23.3385C19.3764 23.3206 19.5115 23.1735 19.5353 22.9507V22.9521Z"
      fill="#1E3A8A"
    />
    <path
      d="M19.5405 22.9491C19.5166 23.1708 19.3813 23.3195 19.1387 23.3374C18.9145 23.3539 18.7077 23.1281 18.7302 22.8941C18.7541 22.6407 18.9 22.4989 19.1466 22.4962C19.3654 22.492 19.5431 22.693 19.5405 22.9505V22.9491Z"
      fill="white"
    />
    <path
      d="M51.448 10.3543C52.1878 10.4879 52.7959 10.8459 53.2724 11.4286C53.7488 12.0112 53.9871 12.6788 53.9871 13.4314C53.9871 14.1111 53.8115 14.712 53.4604 15.2339C53.1219 15.7437 52.6266 16.1443 51.9746 16.4356C51.3226 16.7269 50.5515 16.8725 49.6612 16.8725H44V4.16387H49.4167C50.307 4.16387 51.0718 4.30345 51.7113 4.58263C52.3633 4.86181 52.8523 5.25023 53.1783 5.7479C53.5169 6.24556 53.6861 6.80999 53.6861 7.44118C53.6861 8.18161 53.4793 8.80065 53.0655 9.29832C52.6642 9.79598 52.1251 10.148 51.448 10.3543ZM46.6331 9.40756H49.0406C49.6675 9.40756 50.1502 9.27404 50.4888 9.007C50.8273 8.72782 50.9966 8.33333 50.9966 7.82353C50.9966 7.31373 50.8273 6.91923 50.4888 6.64006C50.1502 6.36088 49.6675 6.22129 49.0406 6.22129H46.6331V9.40756ZM49.2851 14.7969C49.9245 14.7969 50.4198 14.6513 50.7709 14.3599C51.1345 14.0686 51.3163 13.6559 51.3163 13.1218C51.3163 12.5756 51.1282 12.1508 50.7521 11.8473C50.3759 11.5317 49.8681 11.3739 49.2286 11.3739H46.6331V14.7969H49.2851Z"
      fill="#1E3A8A"
    />
    <path
      d="M57.1765 4.16387V12.0294C57.1765 12.8912 57.4085 13.5528 57.8724 14.014C58.3363 14.4631 58.9883 14.6877 59.8284 14.6877C60.6811 14.6877 61.3393 14.4631 61.8033 14.014C62.2672 13.5528 62.4992 12.8912 62.4992 12.0294V4.16387H65.1511V12.0112C65.1511 13.0915 64.9066 14.0079 64.4176 14.7605C63.9411 15.5009 63.2954 16.0593 62.4804 16.4356C61.6779 16.8119 60.7814 17 59.7908 17C58.8128 17 57.9226 16.8119 57.1201 16.4356C56.3301 16.0593 55.7032 15.5009 55.2393 14.7605C54.7753 14.0079 54.5434 13.0915 54.5434 12.0112V4.16387H57.1765Z"
      fill="#1E3A8A"
    />
    <path
      d="M68.8237 4.16387V16.8725H66.1905V4.16387H68.8237Z"
      fill="#1E3A8A"
    />
    <path
      d="M72.5537 14.8515H76.8795V16.8725H69.9206V4.16387H72.5537V14.8515Z"
      fill="#1E3A8A"
    />
    <path
      d="M81.6377 4.16387C83.0169 4.16387 84.2269 4.42484 85.2676 4.94678C86.3209 5.46872 87.1296 6.21522 87.6939 7.18627C88.2706 8.14519 88.559 9.2619 88.559 10.5364C88.559 11.8109 88.2706 12.9276 87.6939 13.8866C87.1296 14.8333 86.3209 15.5677 85.2676 16.0896C84.2269 16.6116 83.0169 16.8725 81.6377 16.8725H77.0485V4.16387H81.6377ZM81.5436 14.7059C82.9229 14.7059 83.9887 14.3417 84.741 13.6134C85.4933 12.8852 85.8695 11.8595 85.8695 10.5364C85.8695 9.21335 85.4933 8.18161 84.741 7.44118C83.9887 6.68861 82.9229 6.31232 81.5436 6.31232H79.6816V14.7059H81.5436Z"
      fill="#1E3A8A"
    />
    <path
      d="M100.936 4.16387V6.22129H97.4379V16.8725H94.8048V6.22129H91.3065V4.16387H100.936Z"
      fill="#1E3A8A"
    />
    <path
      d="M108.124 16.8725L105.227 11.9202H103.986V16.8725H101.353V4.16387H106.28C107.296 4.16387 108.161 4.33987 108.876 4.69188C109.591 5.03175 110.124 5.49907 110.475 6.09384C110.838 6.67647 111.02 7.33193 111.02 8.06022C111.02 8.89776 110.769 9.6564 110.268 10.3361C109.766 11.0037 109.02 11.465 108.03 11.7199L111.171 16.8725H108.124ZM103.986 10.0084H106.186C106.901 10.0084 107.434 9.84454 107.785 9.51681C108.136 9.17694 108.312 8.70962 108.312 8.11485C108.312 7.53221 108.136 7.0831 107.785 6.76751C107.434 6.43978 106.901 6.27591 106.186 6.27591H103.986V10.0084Z"
      fill="#1E3A8A"
    />
    <path
      d="M119.947 14.451H114.718L113.853 16.8725H111.088L115.809 4.14566H118.875L123.596 16.8725H120.812L119.947 14.451ZM119.232 12.4118L117.333 7.09524L115.433 12.4118H119.232Z"
      fill="#1E3A8A"
    />
    <path
      d="M123.216 10.5C123.216 9.24977 123.504 8.13305 124.081 7.14986C124.671 6.15453 125.467 5.38375 126.47 4.83754C127.486 4.27918 128.62 4 129.874 4C131.341 4 132.626 4.36415 133.73 5.09244C134.833 5.82073 135.604 6.8282 136.043 8.11485H133.015C132.714 7.50794 132.288 7.05275 131.736 6.7493C131.197 6.44584 130.57 6.29412 129.855 6.29412C129.09 6.29412 128.407 6.47012 127.805 6.82213C127.216 7.162 126.752 7.64753 126.413 8.27871C126.087 8.9099 125.924 9.65033 125.924 10.5C125.924 11.3375 126.087 12.078 126.413 12.7213C126.752 13.3525 127.216 13.8441 127.805 14.1961C128.407 14.5359 129.09 14.7059 129.855 14.7059C130.57 14.7059 131.197 14.5542 131.736 14.2507C132.288 13.9351 132.714 13.4739 133.015 12.8669H136.043C135.604 14.1657 134.833 15.1793 133.73 15.9076C132.639 16.6237 131.354 16.9818 129.874 16.9818C128.62 16.9818 127.486 16.7087 126.47 16.1625C125.467 15.6041 124.671 14.8333 124.081 13.8501C123.504 12.8669 123.216 11.7502 123.216 10.5Z"
      fill="#1E3A8A"
    />
    <path
      d="M144.198 16.8725L139.421 11.2101V16.8725H136.788V4.16387H139.421V9.86274L144.198 4.16387H147.376L141.96 10.4636L147.527 16.8725H144.198Z"
      fill="#1E3A8A"
    />
    <path
      d="M165.044 4.16387V16.8725H162.411V8.60644L158.894 16.8725H156.9L153.364 8.60644V16.8725H150.731V4.16387H153.722L157.897 13.6134L162.072 4.16387H165.044Z"
      fill="#1E3A8A"
    />
    <path
      d="M174.193 14.451H168.964L168.099 16.8725H165.334L170.055 4.14566H173.121L177.841 16.8725H175.058L174.193 14.451ZM173.478 12.4118L171.578 7.09524L169.679 12.4118H173.478Z"
      fill="#1E3A8A"
    />
    <path
      d="M189.33 16.8725H186.697L180.734 8.15126V16.8725H178.101V4.14566H180.734L186.697 12.8852V4.14566H189.33V16.8725Z"
      fill="#1E3A8A"
    />
    <path
      d="M198.477 14.451H193.248L192.383 16.8725H189.618L194.339 4.14566H197.405L202.126 16.8725H199.342L198.477 14.451ZM197.762 12.4118L195.863 7.09524L193.963 12.4118H197.762Z"
      fill="#1E3A8A"
    />
    <path
      d="M211.526 7.98739C211.226 7.45331 210.812 7.04669 210.285 6.76751C209.758 6.48833 209.144 6.34874 208.442 6.34874C207.665 6.34874 206.975 6.51867 206.373 6.85854C205.771 7.19841 205.301 7.68394 204.962 8.31513C204.624 8.94631 204.455 9.6746 204.455 10.5C204.455 11.3497 204.624 12.0901 204.962 12.7213C205.314 13.3525 205.796 13.838 206.411 14.1779C207.025 14.5177 207.74 14.6877 208.555 14.6877C209.558 14.6877 210.379 14.4328 211.019 13.923C211.658 13.401 212.078 12.6788 212.279 11.7563H207.765V9.80812H214.874V12.0294C214.699 12.9155 214.323 13.7348 213.746 14.4874C213.169 15.24 212.423 15.8469 211.508 16.3081C210.605 16.7572 209.589 16.9818 208.461 16.9818C207.194 16.9818 206.047 16.7087 205.019 16.1625C204.003 15.6041 203.201 14.8333 202.611 13.8501C202.035 12.8669 201.746 11.7502 201.746 10.5C201.746 9.24977 202.035 8.13305 202.611 7.14986C203.201 6.15453 204.003 5.38375 205.019 4.83754C206.047 4.27918 207.188 4 208.442 4C209.921 4 211.207 4.35201 212.298 5.05602C213.388 5.7479 214.141 6.72502 214.555 7.98739H211.526Z"
      fill="#1E3A8A"
    />
    <path
      d="M217.951 6.22129V9.40756H222.371V11.4286H217.951V14.7969H222.935V16.8725H215.318V4.14566H222.935V6.22129H217.951Z"
      fill="#1E3A8A"
    />
    <path
      d="M238.136 4.16387V16.8725H235.503V8.60644L231.986 16.8725H229.992L226.456 8.60644V16.8725H223.823V4.16387H226.814L230.989 13.6134L235.164 4.16387H238.136Z"
      fill="#1E3A8A"
    />
    <path
      d="M241.868 6.22129V9.40756H246.288V11.4286H241.868V14.7969H246.852V16.8725H239.235V4.14566H246.852V6.22129H241.868Z"
      fill="#1E3A8A"
    />
    <path
      d="M258.969 16.8725H256.336L250.373 8.15126V16.8725H247.74V4.14566H250.373L256.336 12.8852V4.14566H258.969V16.8725Z"
      fill="#1E3A8A"
    />
    <path
      d="M269 4.16387V6.22129H265.502V16.8725H262.869V6.22129H259.37V4.16387H269Z"
      fill="#1E3A8A"
    />
    <path
      d="M44.8115 35.994C44.713 35.994 44.6022 35.9155 44.4791 35.7585C44.356 35.6016 44.3006 35.4507 44.3129 35.3058C44.3252 35.1126 44.3806 34.8349 44.4791 34.4727C44.5776 34.1105 44.6884 33.7423 44.8115 33.368C44.9346 32.9937 45.0454 32.6979 45.1439 32.4806C45.1932 32.2874 45.2362 32.1184 45.2732 31.9735C45.3224 31.8166 45.3532 31.714 45.3655 31.6657C45.4025 31.6174 45.4579 31.4906 45.5317 31.2853C45.6179 31.0801 45.6856 30.8809 45.7349 30.6877C45.7595 30.5911 45.8087 30.41 45.8826 30.1444C45.9688 29.8667 46.0673 29.5468 46.1781 29.1846C46.3012 28.8224 46.4182 28.4662 46.529 28.1161C46.6521 27.766 46.7567 27.4581 46.8429 27.1925C46.9291 26.9269 46.9845 26.7518 47.0091 26.6673C47.1076 26.5224 47.1815 26.3836 47.2308 26.2508C47.28 26.1179 47.3108 26.0274 47.3231 25.9791C47.397 25.9308 47.4401 25.8704 47.4524 25.798C47.4647 25.7135 47.4708 25.6471 47.4708 25.5988C47.4708 25.5384 47.4893 25.4901 47.5262 25.4539C47.5755 25.4177 47.6001 25.3754 47.6001 25.3271C47.6494 25.2909 47.6801 25.2366 47.6924 25.1642C47.7048 25.0796 47.7417 25.0072 47.8032 24.9468L47.8956 24.639L48.9852 24.6208C48.9606 24.7657 48.9236 24.9468 48.8744 25.1642C48.8251 25.3694 48.7082 25.6471 48.5235 25.9972C48.4619 26.2387 48.3881 26.456 48.3019 26.6492C48.228 26.8423 48.1972 26.9691 48.2095 27.0295C48.1849 27.0536 48.1295 27.1744 48.0433 27.3917C47.9695 27.609 47.8771 27.8746 47.7663 28.1885C47.6678 28.5024 47.5632 28.8163 47.4524 29.1303C47.3539 29.4442 47.2615 29.7218 47.1753 29.9633C47.1015 30.1927 47.0522 30.3376 47.0276 30.398C46.9291 30.5911 46.8183 30.8749 46.6952 31.2491C46.5721 31.6234 46.3874 32.1305 46.1412 32.7704C46.0427 32.9635 45.9195 33.2533 45.7718 33.6397C45.6364 34.026 45.5256 34.3761 45.4394 34.69C45.304 35.1609 45.2055 35.4869 45.1439 35.668C45.0947 35.8612 45.0516 35.9638 45.0146 35.9759C44.9777 36 44.91 36.006 44.8115 35.994ZM44.9592 25.2004C44.6145 25.2124 44.356 25.1943 44.1836 25.146C44.0235 25.0977 43.9681 24.977 44.0174 24.7838C44.0543 24.639 44.1343 24.5303 44.2575 24.4579C44.3806 24.3854 44.5591 24.3311 44.793 24.2949C44.9285 24.2707 45.1008 24.2405 45.3101 24.2043C45.5317 24.1681 45.741 24.1319 45.938 24.0957C46.3443 24.0474 46.6767 24.0051 46.9353 23.9689C47.2061 23.9327 47.4831 23.9025 47.7663 23.8783C48.0495 23.8542 48.4065 23.83 48.8374 23.8059C49.1945 23.7818 49.4961 23.7636 49.7424 23.7516C50.0009 23.7274 50.1302 23.7153 50.1302 23.7153C50.1671 23.7153 50.2964 23.7274 50.518 23.7516C50.7396 23.7757 50.9797 23.8059 51.2382 23.8421C51.4968 23.8783 51.6876 23.9206 51.8107 23.9689C52.0939 24.0293 52.297 24.1138 52.4202 24.2224C52.5556 24.3311 52.6479 24.488 52.6972 24.6933C52.7341 24.8382 52.7341 24.9287 52.6972 24.9649C52.6602 24.9891 52.5925 25.0253 52.494 25.0736C52.2109 25.1581 52.0016 25.2004 51.8661 25.2004C51.7307 25.2004 51.5768 25.1702 51.4044 25.1098C51.3429 25.0495 51.269 24.9951 51.1828 24.9468C51.109 24.8985 50.9735 24.8623 50.7765 24.8382C50.5919 24.802 50.2964 24.7718 49.8901 24.7476C49.5454 24.7838 49.2437 24.802 48.9852 24.802C48.7266 24.802 48.5974 24.8321 48.5974 24.8925L47.5078 24.9468L46.6029 25.0374C46.4797 25.0495 46.3074 25.0676 46.0858 25.0917C45.8641 25.1038 45.6487 25.1219 45.4394 25.146C45.2301 25.1581 45.07 25.1762 44.9592 25.2004Z"
      fill="#F97316"
    />
    <path
      d="M50.0181 34.5633C49.9073 34.4788 49.8272 34.3942 49.778 34.3097C49.7411 34.2252 49.7411 34.0622 49.778 33.8208C49.8149 33.4827 49.8642 33.1869 49.9257 32.9334C49.9873 32.6677 50.0612 32.3659 50.1473 32.0279C50.172 31.883 50.2397 31.6355 50.3505 31.2853C50.4736 30.9352 50.6213 30.5549 50.7937 30.1444C50.9661 29.7339 51.1384 29.3476 51.3108 28.9854C51.4832 28.6111 51.6309 28.3334 51.754 28.1523C51.8525 28.0799 51.9695 28.0497 52.1049 28.0618C52.2527 28.0738 52.3758 28.1282 52.4743 28.2248C52.6097 28.3334 52.6282 28.5266 52.5297 28.8043C52.4435 29.0699 52.2588 29.4925 51.9756 30.072C51.8279 30.398 51.7171 30.6455 51.6432 30.8145C51.5693 30.9714 51.5386 31.068 51.5509 31.1042C51.5632 31.1284 51.6186 31.1103 51.7171 31.0499C51.791 30.9171 51.9264 30.7662 52.1234 30.5972C52.3204 30.4161 52.5297 30.241 52.7513 30.072C52.9729 29.9029 53.1822 29.752 53.3792 29.6192C53.5762 29.4864 53.7116 29.4019 53.7855 29.3657C53.884 29.3053 53.9948 29.257 54.1179 29.2208C54.2533 29.1725 54.3457 29.1363 54.3949 29.1121C54.6781 28.9793 54.9674 28.931 55.2629 28.9673C55.5584 29.0035 55.743 29.1121 55.8169 29.2932C55.8292 29.3898 55.8662 29.4623 55.9277 29.5106C56.0016 29.5589 56.0385 29.583 56.0385 29.583C56.0878 29.583 56.1124 29.6011 56.1124 29.6373C56.1247 29.6736 56.1309 29.6917 56.1309 29.6917C56.1309 29.7762 56.0631 29.8305 55.9277 29.8547C55.8046 29.8667 55.6445 29.8788 55.4476 29.8909C55.2875 29.9029 55.1459 29.9331 55.0228 29.9814C54.8997 30.0297 54.7519 30.0901 54.5796 30.1625C54.1117 30.4281 53.6623 30.6877 53.2314 30.9413C52.8128 31.1948 52.4065 31.5329 52.0126 31.9554C51.9264 32.052 51.8402 32.1667 51.754 32.2995C51.6678 32.4323 51.5755 32.5772 51.477 32.7342C51.4155 32.7945 51.3539 32.9273 51.2923 33.1326C51.2308 33.3378 51.1754 33.537 51.1261 33.7302C51.0892 33.9113 51.0707 34.02 51.0707 34.0562C51.0707 34.0562 51.0523 34.1166 51.0153 34.2373C50.9784 34.3459 50.9168 34.4546 50.8306 34.5633C50.6829 34.7564 50.5598 34.853 50.4613 34.853C50.3628 34.853 50.2151 34.7564 50.0181 34.5633Z"
      fill="#F97316"
    />
    <path
      d="M56.3611 34.5452C56.3119 34.4486 56.2503 34.3761 56.1764 34.3278C56.1026 34.2675 56.0656 34.2131 56.0656 34.1648C56.0656 34.1166 56.0595 34.0683 56.0472 34.02C56.0472 33.9596 56.0226 33.9053 55.9733 33.857C55.9117 33.7845 55.9179 33.6215 55.9918 33.368C56.0656 33.1024 56.1888 32.7824 56.3611 32.4082C56.5335 32.0218 56.7366 31.6174 56.9706 31.1948C57.0691 31.0982 57.1675 30.9714 57.266 30.8145C57.3645 30.6575 57.4384 30.5549 57.4877 30.5066C57.4877 30.4583 57.5061 30.4161 57.5431 30.3798C57.58 30.3316 57.6231 30.3074 57.6723 30.3074V30.1987C57.6723 30.1384 57.7277 30.0358 57.8385 29.8909C57.9617 29.746 58.1094 29.589 58.2818 29.42C58.4541 29.2389 58.6326 29.0699 58.8173 28.9129C59.002 28.7439 59.1559 28.6232 59.279 28.5507C59.5376 28.3817 59.8023 28.2791 60.0731 28.2429C60.3563 28.2066 60.5964 28.267 60.7934 28.424C60.8303 28.4602 60.8919 28.5205 60.978 28.6051C61.0642 28.6896 61.1627 28.7862 61.2735 28.8948C61.3966 28.9914 61.5198 29.094 61.6429 29.2027L62.3262 29.8003L61.9938 30.7058C61.8337 31.1888 61.7906 31.6113 61.8645 31.9735C61.9507 32.3357 62.0738 32.6496 62.2338 32.9153C62.2954 33.0481 62.4185 33.1748 62.6032 33.2956C62.8002 33.4163 62.9849 33.4887 63.1572 33.5129C63.2557 33.525 63.3481 33.5612 63.4342 33.6215C63.5204 33.6819 63.5635 33.7785 63.5635 33.9113C63.5635 34.032 63.5389 34.1286 63.4896 34.2011C63.4404 34.2735 63.3542 34.3218 63.2311 34.3459C62.8248 34.3942 62.4431 34.2977 62.0861 34.0562C61.7414 33.8147 61.4213 33.4163 61.1258 32.8609C61.0765 32.7885 61.0088 32.6557 60.9226 32.4625C60.8488 32.2573 60.8057 32.1244 60.7934 32.0641C60.7441 32.1244 60.6518 32.2391 60.5163 32.4082C60.3809 32.5651 60.2763 32.6798 60.2024 32.7523C59.3283 33.6215 58.5711 34.2071 57.9309 34.5089C57.303 34.7987 56.7797 34.8108 56.3611 34.5452ZM57.026 33.531C57.026 33.6155 57.1552 33.6155 57.4138 33.531C57.6846 33.4344 57.974 33.2654 58.2818 33.0239C58.7004 32.6738 59.119 32.2874 59.5376 31.8649C59.9685 31.4423 60.3132 31.0499 60.5717 30.6877L60.978 30.0358C60.8549 29.7581 60.7195 29.5709 60.5717 29.4743C60.4363 29.3657 60.3194 29.3114 60.2209 29.3114C60.0608 29.3114 59.8207 29.4562 59.5006 29.746C59.1928 30.0358 58.8604 30.4221 58.5034 30.905C58.1463 31.388 57.8078 31.9192 57.4877 32.4987C57.3645 32.7402 57.2537 32.9756 57.1552 33.205C57.0691 33.4223 57.026 33.531 57.026 33.531Z"
      fill="#F97316"
    />
    <path
      d="M66.2325 34.7806C65.9617 34.7806 65.7585 34.7685 65.6231 34.7444C65.4877 34.7202 65.383 34.684 65.3091 34.6357C65.2353 34.5874 65.1491 34.521 65.0506 34.4365C65.0013 34.3399 64.9398 34.2373 64.8659 34.1286C64.792 34.02 64.7305 33.9415 64.6812 33.8932C64.632 33.7121 64.6074 33.4767 64.6074 33.1869C64.6197 32.8971 64.6566 32.5832 64.7182 32.2452C64.792 31.9071 64.8905 31.5932 65.0137 31.3035C65.0629 31.2069 65.106 31.1103 65.1429 31.0137C65.1799 30.9171 65.1983 30.8688 65.1983 30.8688C65.1983 30.8085 65.2722 30.6636 65.4199 30.4342C65.58 30.2048 65.7524 29.9633 65.937 29.7098C66.134 29.4562 66.2941 29.2751 66.4172 29.1665C66.5034 29.0699 66.6326 28.9673 66.805 28.8586C66.9897 28.7499 67.1497 28.6715 67.2852 28.6232C67.4206 28.5749 67.556 28.5326 67.6915 28.4964C67.8392 28.4602 68.0054 28.4421 68.1901 28.4421C68.3625 28.4421 68.5225 28.4783 68.6702 28.5507C68.818 28.6232 68.9596 28.7499 69.095 28.931C69.3166 29.1484 69.4397 29.3657 69.4644 29.583C69.5013 29.7883 69.4951 29.9995 69.4459 30.2169C69.3843 30.4583 69.3043 30.6455 69.2058 30.7783C69.1073 30.899 68.9965 30.9533 68.8734 30.9413C68.7503 30.9292 68.6087 30.8386 68.4486 30.6696C68.3994 30.573 68.3748 30.4945 68.3748 30.4342C68.3748 30.3617 68.3994 30.2591 68.4486 30.1263C68.4979 29.9573 68.4979 29.7822 68.4486 29.6011C68.3994 29.42 68.3194 29.3295 68.2086 29.3295C68.0485 29.3295 67.87 29.4019 67.673 29.5468C67.4883 29.6796 67.2975 29.8486 67.1005 30.0539C67.0143 30.1505 66.8912 30.3014 66.7311 30.5066C66.5834 30.6998 66.4357 30.9171 66.2879 31.1586C66.1402 31.388 66.0171 31.6113 65.9186 31.8287C65.7831 32.2271 65.6723 32.547 65.5861 32.7885C65.5123 33.03 65.4753 33.1507 65.4753 33.1507C65.4753 33.199 65.4877 33.2473 65.5123 33.2956C65.5492 33.3318 65.5677 33.374 65.5677 33.4223C65.5677 33.5672 65.6539 33.6819 65.8262 33.7664C65.9617 33.8509 66.1217 33.8992 66.3064 33.9113C66.4911 33.9113 66.7188 33.8509 66.9897 33.7302C67.1867 33.6336 67.3714 33.5068 67.5437 33.3499C67.7284 33.1929 67.9192 33.0541 68.1162 32.9334C68.2516 32.8489 68.3563 32.7764 68.4302 32.716C68.5163 32.6557 68.5594 32.6496 68.5594 32.6979C68.5594 32.7462 68.5779 32.7704 68.6148 32.7704C68.6518 32.7704 68.6949 32.7462 68.7441 32.6979C68.818 32.6013 68.898 32.541 68.9842 32.5168C69.0704 32.4806 69.1442 32.4685 69.2058 32.4806C69.2797 32.4806 69.3166 32.4987 69.3166 32.5349C69.292 32.6436 69.3166 32.7342 69.3905 32.8066C69.3905 32.8549 69.372 32.9213 69.3351 33.0058C69.3105 33.0782 69.2735 33.1386 69.2243 33.1869C69.1627 33.2714 69.0704 33.368 68.9473 33.4767C68.8365 33.5853 68.7318 33.6819 68.6333 33.7664C68.5348 33.8389 68.4856 33.8751 68.4856 33.8751C68.4363 33.863 68.3871 33.8751 68.3378 33.9113C68.3009 33.9475 68.2578 33.9898 68.2086 34.0381C68.1101 34.1226 68.0177 34.189 67.9315 34.2373C67.8454 34.2735 67.7776 34.2916 67.7284 34.2916C67.6422 34.3399 67.5745 34.3701 67.5253 34.3822C67.4883 34.3942 67.4698 34.4244 67.4698 34.4727C67.3467 34.5935 67.1928 34.678 67.0082 34.7263C66.8358 34.7625 66.5772 34.7806 66.2325 34.7806Z"
      fill="#F97316"
    />
    <path
      d="M75.5326 35.2333C75.4833 35.2816 75.3479 35.2997 75.1263 35.2877C74.917 35.2756 74.72 35.2273 74.5353 35.1428C74.5107 35.1066 74.4676 35.0704 74.406 35.0341C74.3445 34.9858 74.2829 34.9315 74.2214 34.8711C74.1721 34.8108 74.129 34.7564 74.0921 34.7081C74.0675 34.6719 74.0059 34.6055 73.9074 34.5089C73.8089 34.4003 73.7104 34.2977 73.6119 34.2011C73.5134 34.1045 73.4457 34.0381 73.4088 34.0019C73.3595 33.9053 73.261 33.7845 73.1133 33.6397C72.9656 33.4827 72.824 33.3378 72.6885 33.205C72.6024 33.0843 72.5162 32.9817 72.43 32.8971C72.3438 32.8126 72.2699 32.7523 72.2084 32.716C72.1468 32.6678 72.0976 32.6436 72.0606 32.6436C72.0606 32.6436 72.036 32.7221 71.9868 32.879C71.9498 33.0239 71.8944 33.2111 71.8206 33.4404C71.759 33.6578 71.6913 33.8811 71.6174 34.1105C71.5559 34.3278 71.5066 34.5029 71.4697 34.6357C71.3835 34.8047 71.3096 34.9194 71.2481 34.9798C71.1865 35.0402 71.1065 35.0704 71.008 35.0704C70.8726 35.0704 70.7494 35.01 70.6386 34.8893C70.5401 34.7685 70.4909 34.5935 70.4909 34.3641C70.4416 34.195 70.5032 33.8268 70.6756 33.2593C70.8479 32.6919 71.1126 31.9675 71.4697 31.0861C71.5189 30.905 71.5805 30.7179 71.6544 30.5247C71.7282 30.3195 71.7898 30.1505 71.839 30.0176C71.9621 29.6192 72.0914 29.251 72.2269 28.9129C72.3746 28.5628 72.5285 28.2127 72.6885 27.8625C72.8486 27.5003 73.0148 27.114 73.1872 26.7035C73.298 26.4862 73.378 26.3292 73.4272 26.2326C73.4765 26.124 73.5319 26.0153 73.5935 25.9067C73.655 25.7859 73.7474 25.6109 73.8705 25.3815C74.1413 24.8865 74.3568 24.5001 74.5168 24.2224C74.6769 23.9447 74.8 23.7395 74.8862 23.6067C74.9724 23.4739 75.0462 23.3773 75.1078 23.3169C75.1694 23.2566 75.2432 23.2143 75.3294 23.1902C75.4156 23.166 75.5018 23.166 75.588 23.1902C75.6741 23.2022 75.748 23.2445 75.8096 23.3169C75.9081 23.4135 75.9635 23.5161 75.9758 23.6248C76.0004 23.7214 75.9758 23.8542 75.9019 24.0232C75.8404 24.1922 75.7172 24.4277 75.5326 24.7295C75.4341 24.9468 75.354 25.1038 75.2925 25.2004C75.2309 25.297 75.1694 25.3935 75.1078 25.4901C75.0462 25.5867 74.9478 25.7557 74.8123 25.9972C74.7877 26.0697 74.7508 26.1481 74.7015 26.2326C74.6523 26.3172 74.5969 26.3594 74.5353 26.3594C74.5353 26.3956 74.5168 26.4681 74.4799 26.5767C74.443 26.6854 74.3999 26.788 74.3506 26.8846C74.3137 27.0174 74.2521 27.1623 74.166 27.3192C74.0921 27.4641 74.0367 27.5849 73.9997 27.6814C73.9382 27.8263 73.8397 28.0255 73.7043 28.2791C73.5811 28.5326 73.458 28.7801 73.3349 29.0216C73.2241 29.251 73.1564 29.4321 73.1318 29.5649C73.1318 29.6132 73.1687 29.6072 73.2426 29.5468C73.3164 29.4864 73.3965 29.4321 73.4827 29.3838C73.6673 29.2389 73.8766 29.094 74.1106 28.9492C74.3568 28.7922 74.5907 28.6594 74.8123 28.5507C75.0462 28.43 75.2371 28.3576 75.3848 28.3334C75.5695 28.2851 75.7172 28.261 75.828 28.261C75.9512 28.261 76.0743 28.2851 76.1974 28.3334C76.2959 28.3817 76.3759 28.4481 76.4375 28.5326C76.5113 28.6171 76.5729 28.7137 76.6222 28.8224C76.6837 28.931 76.7268 29.0638 76.7514 29.2208C76.7514 29.3295 76.7083 29.5106 76.6222 29.7641C76.536 30.0176 76.4313 30.2652 76.3082 30.5066C76.1851 30.736 76.062 30.899 75.9388 30.9956C75.8527 31.0318 75.785 31.068 75.7357 31.1042C75.6865 31.1405 75.6618 31.1586 75.6618 31.1586C75.6618 31.2069 75.6372 31.2672 75.588 31.3397C75.551 31.4121 75.4833 31.4725 75.3848 31.5208C75.3356 31.5691 75.2802 31.6294 75.2186 31.7019C75.1571 31.7743 75.1263 31.8287 75.1263 31.8649C75.1263 31.8649 75.1263 31.883 75.1263 31.9192C75.1263 31.9433 75.1263 31.9554 75.1263 31.9554C75.077 31.9554 75.0032 31.9916 74.9047 32.0641C74.8185 32.1365 74.7077 32.221 74.5722 32.3176C74.4368 32.4504 74.3383 32.5229 74.2768 32.5349C74.2275 32.547 74.1536 32.5712 74.0551 32.6074C74.0305 32.6315 73.9997 32.6496 73.9628 32.6617C73.9382 32.6738 73.9074 32.6859 73.8705 32.6979C73.8458 32.71 73.8212 32.7221 73.7966 32.7342C73.7966 32.7342 73.7781 32.7643 73.7781 32.7885C73.7781 32.8368 73.8335 32.9394 73.9443 33.0964C74.0675 33.2412 74.209 33.4042 74.3691 33.5853C74.5415 33.7664 74.7015 33.9355 74.8493 34.0924C75.0093 34.2373 75.1263 34.3339 75.2001 34.3822C75.3233 34.4305 75.4094 34.515 75.4587 34.6357C75.5202 34.7444 75.5572 34.8591 75.5695 34.9798C75.5818 35.0885 75.5695 35.173 75.5326 35.2333ZM73.3164 32.0279C73.378 31.9796 73.5073 31.883 73.7043 31.7381C73.9013 31.5811 74.1167 31.4121 74.3506 31.231C74.5846 31.0378 74.7939 30.8567 74.9785 30.6877C75.1755 30.5066 75.3109 30.3738 75.3848 30.2893C75.471 30.2048 75.5572 30.0599 75.6434 29.8547C75.7295 29.6494 75.7419 29.4864 75.6803 29.3657C75.668 29.3174 75.5572 29.3415 75.3479 29.4381C75.1386 29.5347 74.8985 29.6494 74.6276 29.7822C74.4183 29.9029 74.1721 30.0599 73.8889 30.2531C73.6181 30.4463 73.3595 30.6515 73.1133 30.8688C72.8794 31.0861 72.7009 31.2974 72.5777 31.5027C72.5531 31.5872 72.5777 31.6838 72.6516 31.7924C72.7255 31.9011 72.824 31.9856 72.9471 32.046C73.0702 32.0943 73.1933 32.0882 73.3164 32.0279Z"
      fill="#F97316"
    />
    <path
      d="M85.2913 35.6861C85.242 35.7344 85.1866 35.7525 85.1251 35.7404C85.0635 35.7404 84.965 35.7102 84.8296 35.6499C84.5957 35.5895 84.4479 35.499 84.3864 35.3782C84.3371 35.2696 84.374 35.0824 84.4972 34.8168C84.5464 34.7323 84.608 34.5512 84.6818 34.2735C84.768 33.9837 84.8604 33.6517 84.9589 33.2775C85.0573 32.9032 85.1558 32.5289 85.2543 32.1546C85.3528 31.7804 85.439 31.4544 85.5129 31.1767C85.5868 30.8869 85.636 30.6938 85.6606 30.5972C85.6606 30.5006 85.6852 30.3074 85.7345 30.0176C85.7961 29.7279 85.8515 29.4019 85.9007 29.0397C86.0361 28.7862 86.1285 28.5085 86.1777 28.2066C86.2393 27.9048 86.2824 27.6875 86.307 27.5547C86.3562 27.3615 86.4116 27.1563 86.4732 26.9389C86.5471 26.7216 86.6086 26.5043 86.6579 26.287C86.7071 26.0938 86.7564 25.8946 86.8056 25.6893C86.8672 25.4841 86.898 25.3513 86.898 25.2909V25.0012H86.2147C86.03 25.0132 85.7591 25.0132 85.4021 25.0012C85.045 24.9891 84.7249 24.9831 84.4418 24.9831C83.8631 24.9589 83.4753 24.9046 83.2783 24.8201C83.0936 24.7235 82.989 24.5424 82.9643 24.2768C82.9397 24.1319 82.9705 24.0293 83.0567 23.9689C83.1429 23.9085 83.346 23.8723 83.6661 23.8602C83.9862 23.8482 84.4787 23.8542 85.1435 23.8783C85.6606 23.8542 86.11 23.8542 86.4917 23.8783C86.8733 23.8904 87.0888 23.8964 87.138 23.8964C87.1873 23.8482 87.2181 23.7999 87.2304 23.7516C87.2427 23.7033 87.2612 23.655 87.2858 23.6067C87.2858 23.5463 87.2919 23.4799 87.3042 23.4075C87.3289 23.323 87.3904 23.2626 87.4889 23.2264C87.5874 23.0453 87.6982 22.9728 87.8213 23.0091C87.9568 23.0332 88.0922 23.1419 88.2276 23.335C88.2769 23.4437 88.32 23.5584 88.3569 23.6791C88.4061 23.7999 88.4739 23.9085 88.56 24.0051C88.6093 23.9568 88.7386 23.9266 88.9479 23.9146C89.1572 23.9025 89.3788 23.8904 89.6127 23.8783C89.8959 23.8783 90.1483 23.8723 90.3699 23.8602C90.5915 23.8361 90.7454 23.824 90.8316 23.824C90.9424 23.7636 91.084 23.7335 91.2563 23.7335C91.441 23.7335 91.6257 23.7455 91.8103 23.7697C92.0935 23.7697 92.2905 23.7818 92.4013 23.8059C92.5244 23.83 92.6045 23.8723 92.6414 23.9327C92.6414 23.981 92.6414 24.0293 92.6414 24.0775C92.6537 24.1258 92.6845 24.1741 92.7337 24.2224C92.783 24.2707 92.8076 24.3069 92.8076 24.3311C92.8076 24.3311 92.783 24.3975 92.7337 24.4941C92.6845 24.5424 92.5983 24.5846 92.4752 24.6208C92.3521 24.645 92.2166 24.6571 92.0689 24.6571C91.9827 24.6571 91.835 24.6691 91.6257 24.6933C91.4164 24.7054 91.2379 24.7114 91.0901 24.7114C90.8069 24.7597 90.4868 24.802 90.1298 24.8382C89.7851 24.8623 89.3972 24.8865 88.9663 24.9106C88.7817 24.9106 88.6093 24.9227 88.4492 24.9468C88.2892 24.9589 88.2092 24.9951 88.2092 25.0555C88.1599 25.0555 88.0922 25.1823 88.006 25.4358C87.9321 25.6893 87.8583 25.955 87.7844 26.2326C87.7105 26.5466 87.6305 26.8182 87.5443 27.0476C87.4705 27.277 87.4089 27.4279 87.3596 27.5003C87.4089 27.5486 87.4274 27.609 87.4151 27.6814C87.4151 27.7539 87.3781 27.8807 87.3042 28.0618C87.255 28.2308 87.2058 28.3636 87.1565 28.4602C87.1196 28.5568 87.1011 28.6534 87.1011 28.7499C87.1011 28.7499 87.0703 28.8465 87.0088 29.0397C86.9595 29.2208 86.9103 29.4502 86.861 29.7279C86.8364 29.9935 86.7995 30.2169 86.7502 30.398C86.7133 30.5791 86.6702 30.6938 86.6209 30.742C86.6209 30.742 86.5963 30.7843 86.5471 30.8688C86.4978 30.9413 86.4732 31.0258 86.4732 31.1224C86.4732 31.231 86.4486 31.4121 86.3993 31.6657C86.3624 31.9071 86.3193 32.1365 86.2701 32.3538C86.2208 32.5712 86.1777 32.6919 86.1408 32.716C86.2639 32.7402 86.2454 32.9032 86.0854 33.205C86.0854 33.3257 86.0669 33.4465 86.03 33.5672C85.993 33.688 85.9746 33.7725 85.9746 33.8208C85.9007 34.0502 85.8145 34.3037 85.716 34.5814C85.6175 34.8591 85.5314 35.1005 85.4575 35.3058C85.3836 35.5231 85.3282 35.6499 85.2913 35.6861Z"
      fill="#F97316"
    />
    <path
      d="M91.3673 34.6357C91.1826 34.6116 91.0225 34.4848 90.8871 34.2554C90.764 34.0139 90.6901 33.7966 90.6655 33.6034C90.6778 33.5068 90.6901 33.368 90.7024 33.1869C90.7271 33.0058 90.7517 32.8187 90.7763 32.6255C90.8255 32.3961 90.8933 32.1184 90.9794 31.7924C91.0656 31.4544 91.1518 31.1163 91.238 30.7783C91.3365 30.4402 91.4227 30.1505 91.4965 29.909C91.5704 29.6675 91.6197 29.5226 91.6443 29.4743C91.7058 29.3778 91.8043 29.3536 91.9398 29.4019C92.0752 29.4502 92.186 29.5226 92.2722 29.6192C92.3461 29.7158 92.3891 29.8305 92.4015 29.9633C92.4261 30.0961 92.4076 30.2893 92.3461 30.5428C92.2968 30.7964 92.1983 31.1707 92.0506 31.6657C91.9151 32.1486 91.8105 32.541 91.7366 32.8428C91.6751 33.1326 91.6504 33.4404 91.6628 33.7664C91.6135 34.1769 91.5766 34.4305 91.5519 34.527C91.5273 34.6116 91.4658 34.6478 91.3673 34.6357ZM93.491 27.4098C93.4418 27.446 93.3926 27.4641 93.3433 27.4641C93.3064 27.4521 93.2387 27.4158 93.1402 27.3555C93.054 27.3434 92.9432 27.2891 92.8077 27.1925C92.6846 27.0838 92.5738 26.9752 92.4753 26.8665C92.3891 26.7458 92.3461 26.6733 92.3461 26.6492C92.3337 26.5284 92.3399 26.3775 92.3645 26.1964C92.4015 26.0033 92.4692 25.8342 92.5677 25.6893C92.6662 25.5324 92.8077 25.4479 92.9924 25.4358C93.0417 25.4358 93.0848 25.4418 93.1217 25.4539C93.1586 25.466 93.2694 25.5082 93.4541 25.5807C93.5526 25.7618 93.6511 25.967 93.7496 26.1964C93.8481 26.4137 93.8912 26.6311 93.8789 26.8484C93.8666 27.0536 93.7373 27.2408 93.491 27.4098Z"
      fill="#F97316"
    />
    <path
      d="M102.217 34.4365C102.156 34.4124 102.064 34.352 101.94 34.2554C101.817 34.1588 101.713 33.9958 101.626 33.7664C101.54 33.525 101.497 33.1929 101.497 32.7704C101.51 32.4082 101.516 32.1244 101.516 31.9192C101.528 31.714 101.485 31.6113 101.386 31.6113C101.288 31.6113 101.097 31.7079 100.814 31.9011C100.543 32.0822 100.229 32.3297 99.8721 32.6436C99.515 32.9575 99.1518 33.3076 98.7825 33.694C98.6593 33.8268 98.5362 33.9536 98.4131 34.0743C98.3023 34.183 98.1915 34.2554 98.0807 34.2916C97.9699 34.3158 97.8406 34.2735 97.6929 34.1648L97.4897 34.0019C97.4282 33.9415 97.3912 33.8811 97.3789 33.8208C97.3666 33.7483 97.3728 33.6698 97.3974 33.5853L97.8221 32.3901C98.0191 31.9554 98.1546 31.6415 98.2284 31.4483C98.3023 31.2431 98.3392 31.1163 98.3392 31.068C98.3392 31.0077 98.3208 30.9835 98.2838 30.9956C98.1853 31.0077 98.0376 31.068 97.8406 31.1767C97.6436 31.2733 97.5143 31.3699 97.4528 31.4665C97.4035 31.4665 97.3297 31.5208 97.2312 31.6294C97.1327 31.7381 97.0096 31.8407 96.8618 31.9373C96.7756 32.0822 96.6033 32.2693 96.3447 32.4987C96.0985 32.7281 95.8523 32.9635 95.606 33.205C95.446 33.3378 95.2859 33.5008 95.1259 33.694C94.9781 33.8872 94.8489 34.0562 94.738 34.2011C94.6396 34.3459 94.5718 34.4184 94.5349 34.4184C94.3748 34.4184 94.2271 34.3761 94.0917 34.2916C93.9686 34.2071 93.8762 34.0683 93.8147 33.8751C93.7162 33.6698 93.7162 33.3861 93.8147 33.0239C93.9132 32.6496 94.024 32.1667 94.1471 31.5751C94.1963 31.394 94.2271 31.2612 94.2394 31.1767C94.2517 31.0922 94.2702 31.0077 94.2948 30.9231C94.3318 30.8266 94.3872 30.6817 94.461 30.4885C94.5472 30.2953 94.6765 30.0056 94.8488 29.6192C94.935 29.3898 94.9843 29.2208 94.9966 29.1121C95.0212 28.9914 95.0335 28.9069 95.0335 28.8586C95.0335 28.7379 95.0643 28.6352 95.1259 28.5507C95.1997 28.4662 95.2859 28.4059 95.3844 28.3696C95.4829 28.3334 95.5752 28.3274 95.6614 28.3515C95.7969 28.3757 95.9138 28.4421 96.0123 28.5507C96.1231 28.6594 96.1847 28.8103 96.197 29.0035C96.2093 29.1484 96.197 29.2812 96.1601 29.4019C96.1231 29.5106 96.0862 29.6132 96.0492 29.7098L95.8461 30.1987C95.7845 30.3316 95.7045 30.5247 95.606 30.7783C95.5075 31.0318 95.4213 31.2672 95.3475 31.4846C95.2736 31.6898 95.2367 31.8105 95.2367 31.8468C95.249 31.883 95.2921 31.8769 95.3659 31.8287C95.4398 31.7683 95.5322 31.6898 95.643 31.5932C95.7661 31.4846 95.8892 31.3819 96.0123 31.2853C96.2709 31.0439 96.5602 30.8145 96.8803 30.5972C97.2127 30.3678 97.5267 30.1746 97.8221 30.0176C98.1176 29.8607 98.3454 29.7581 98.5054 29.7098C98.7147 29.7098 98.8563 29.746 98.9302 29.8184C99.0164 29.8909 99.158 30.0237 99.355 30.2169C99.4411 30.3014 99.4904 30.41 99.5027 30.5428C99.515 30.6756 99.5089 30.8024 99.4842 30.9231C99.4719 30.9714 99.435 31.0922 99.3734 31.2853C99.3119 31.4665 99.2503 31.6415 99.1887 31.8105C99.1395 31.9796 99.1149 32.0641 99.1149 32.0641C99.1149 32.0641 99.1826 32.0037 99.318 31.883C99.4658 31.7622 99.6258 31.6355 99.7982 31.5027C99.9705 31.3578 100.1 31.2491 100.186 31.1767C100.666 30.8145 101.085 30.5851 101.442 30.4885C101.799 30.3919 102.088 30.5187 102.31 30.8688C102.458 31.0016 102.531 31.1465 102.531 31.3035C102.544 31.4604 102.55 31.7321 102.55 32.1184C102.562 32.2754 102.574 32.4625 102.587 32.6798C102.599 32.8971 102.611 33.0964 102.624 33.2775C102.648 33.4465 102.673 33.5491 102.698 33.5853C102.735 33.6336 102.802 33.6759 102.901 33.7121C103.012 33.7362 103.153 33.7604 103.326 33.7845C103.51 33.8087 103.621 33.8872 103.658 34.02C103.695 34.1528 103.615 34.2795 103.418 34.4003C103.233 34.5089 103.03 34.5572 102.808 34.5452C102.587 34.5331 102.39 34.4969 102.217 34.4365Z"
      fill="#F97316"
    />
    <path
      d="M105.515 34.7625C105.035 34.5693 104.721 34.3037 104.573 33.9656C104.438 33.6155 104.413 33.0782 104.499 32.3538C104.524 31.9796 104.536 31.7321 104.536 31.6113C104.536 31.4906 104.469 31.3699 104.333 31.2491C104.296 31.2008 104.229 31.1344 104.13 31.0499C104.044 30.9654 104.007 30.893 104.019 30.8326C104.007 30.7481 104.013 30.6575 104.038 30.5609C104.062 30.4523 104.099 30.398 104.149 30.398C104.198 30.398 104.247 30.3859 104.296 30.3617C104.358 30.3376 104.413 30.3376 104.463 30.3617C104.512 30.3617 104.567 30.3678 104.629 30.3798C104.69 30.3919 104.721 30.4221 104.721 30.4704C104.77 30.5549 104.85 30.567 104.961 30.5066C105.072 30.4342 105.189 30.2772 105.312 30.0358C105.435 29.8426 105.595 29.6494 105.792 29.4562C106.002 29.2631 106.205 29.088 106.402 28.931C106.611 28.762 106.783 28.6413 106.919 28.5688C106.98 28.5447 107.073 28.5145 107.196 28.4783C107.319 28.4421 107.448 28.4119 107.584 28.3877C107.731 28.3636 107.854 28.3576 107.953 28.3696C108.175 28.3817 108.359 28.4421 108.507 28.5507C108.667 28.6594 108.815 28.7862 108.95 28.931C109.11 29.0397 109.209 29.1846 109.246 29.3657C109.295 29.5468 109.307 29.74 109.283 29.9452C109.258 30.1505 109.203 30.3376 109.116 30.5066C109.079 30.6274 108.975 30.7722 108.802 30.9413C108.63 31.1103 108.433 31.2733 108.211 31.4302C107.99 31.5872 107.787 31.7019 107.602 31.7743C107.442 31.8105 107.233 31.8407 106.974 31.8649C106.728 31.889 106.494 31.9011 106.272 31.9011C106.063 31.889 105.922 31.8649 105.848 31.8287C105.761 31.7804 105.694 31.8468 105.644 32.0279C105.595 32.209 105.558 32.4685 105.534 32.8066C105.509 33.0722 105.509 33.2654 105.534 33.3861C105.558 33.5068 105.583 33.5914 105.608 33.6397C105.694 33.7242 105.811 33.8328 105.958 33.9656C106.118 34.0864 106.34 34.1045 106.623 34.02C106.857 33.9596 107.085 33.8026 107.307 33.5491C107.541 33.2956 107.756 33.0903 107.953 32.9334C108.002 32.8489 108.082 32.8006 108.193 32.7885C108.316 32.7643 108.445 32.7704 108.581 32.8066C108.716 32.8911 108.772 32.9937 108.747 33.1145C108.735 33.2231 108.673 33.3922 108.562 33.6215C108.525 33.7061 108.439 33.8147 108.304 33.9475C108.181 34.0683 108.039 34.195 107.879 34.3278C107.731 34.4486 107.596 34.5452 107.473 34.6176C107.103 34.8108 106.759 34.9134 106.439 34.9255C106.118 34.9255 105.811 34.8711 105.515 34.7625ZM106.605 31.0861C106.876 31.0258 107.091 30.9835 107.251 30.9594C107.411 30.9352 107.565 30.8688 107.713 30.7602C107.861 30.6394 108.045 30.4161 108.267 30.0901C108.316 29.9573 108.328 29.8245 108.304 29.6917C108.292 29.5589 108.261 29.4683 108.211 29.42C108.101 29.2993 107.965 29.2631 107.805 29.3114C107.657 29.3476 107.516 29.414 107.38 29.5106C107.294 29.5468 107.165 29.6373 106.993 29.7822C106.833 29.915 106.673 30.072 106.512 30.2531C106.352 30.4221 106.223 30.5791 106.125 30.7239C106.026 30.8688 106.002 30.9533 106.051 30.9775C106.026 31.0258 106.094 31.056 106.254 31.068C106.426 31.0801 106.543 31.0861 106.605 31.0861Z"
      fill="#F97316"
    />
    <path
      d="M114.83 34.5452C114.781 34.4486 114.719 34.3761 114.645 34.3278C114.571 34.2675 114.534 34.2131 114.534 34.1648C114.534 34.1166 114.528 34.0683 114.516 34.02C114.516 33.9596 114.491 33.9053 114.442 33.857C114.381 33.7845 114.387 33.6215 114.461 33.368C114.534 33.1024 114.658 32.7824 114.83 32.4082C115.002 32.0218 115.205 31.6174 115.439 31.1948C115.538 31.0982 115.636 30.9714 115.735 30.8145C115.833 30.6575 115.907 30.5549 115.957 30.5066C115.957 30.4583 115.975 30.4161 116.012 30.3798C116.049 30.3316 116.092 30.3074 116.141 30.3074V30.1987C116.141 30.1384 116.197 30.0358 116.307 29.8909C116.431 29.746 116.578 29.589 116.751 29.42C116.923 29.2389 117.101 29.0699 117.286 28.9129C117.471 28.7439 117.625 28.6232 117.748 28.5507C118.006 28.3817 118.271 28.2791 118.542 28.2429C118.825 28.2066 119.065 28.267 119.262 28.424C119.299 28.4602 119.361 28.5205 119.447 28.6051C119.533 28.6896 119.632 28.7862 119.742 28.8948C119.865 28.9914 119.989 29.094 120.112 29.2027L120.795 29.8003L120.463 30.7058C120.303 31.1888 120.259 31.6113 120.333 31.9735C120.42 32.3357 120.543 32.6496 120.703 32.9153C120.764 33.0481 120.887 33.1748 121.072 33.2956C121.269 33.4163 121.454 33.4887 121.626 33.5129C121.725 33.525 121.817 33.5612 121.903 33.6215C121.989 33.6819 122.032 33.7785 122.032 33.9113C122.032 34.032 122.008 34.1286 121.958 34.2011C121.909 34.2735 121.823 34.3218 121.7 34.3459C121.294 34.3942 120.912 34.2977 120.555 34.0562C120.21 33.8147 119.89 33.4163 119.595 32.8609C119.545 32.7885 119.478 32.6557 119.391 32.4625C119.318 32.2573 119.275 32.1244 119.262 32.0641C119.213 32.1244 119.121 32.2391 118.985 32.4082C118.85 32.5651 118.745 32.6798 118.671 32.7523C117.797 33.6215 117.04 34.2071 116.4 34.5089C115.772 34.7987 115.249 34.8108 114.83 34.5452ZM115.495 33.531C115.495 33.6155 115.624 33.6155 115.883 33.531C116.153 33.4344 116.443 33.2654 116.751 33.0239C117.169 32.6738 117.588 32.2874 118.006 31.8649C118.437 31.4423 118.782 31.0499 119.041 30.6877L119.447 30.0358C119.324 29.7581 119.188 29.5709 119.041 29.4743C118.905 29.3657 118.788 29.3114 118.69 29.3114C118.53 29.3114 118.29 29.4562 117.969 29.746C117.662 30.0358 117.329 30.4221 116.972 30.905C116.615 31.388 116.277 31.9192 115.957 32.4987C115.833 32.7402 115.723 32.9756 115.624 33.205C115.538 33.4223 115.495 33.531 115.495 33.531Z"
      fill="#F97316"
    />
    <path
      d="M128.487 34.9798C128.364 34.9798 128.235 34.9134 128.099 34.7806C127.976 34.6478 127.865 34.4848 127.767 34.2916C127.681 34.0864 127.638 33.8932 127.638 33.7121C127.638 33.531 127.681 33.1929 127.767 32.6979C127.865 32.2029 127.982 31.7019 128.118 31.1948C128.216 30.8809 128.247 30.6998 128.21 30.6515C128.173 30.6032 128.007 30.6696 127.712 30.8507C127.539 30.9352 127.385 31.0258 127.25 31.1224C127.114 31.2069 126.998 31.3035 126.899 31.4121C126.837 31.4604 126.745 31.5389 126.622 31.6476C126.499 31.7562 126.37 31.8588 126.234 31.9554C126.074 32.0762 125.871 32.2452 125.625 32.4625C125.379 32.6798 125.132 32.8971 124.886 33.1145C124.652 33.3318 124.474 33.5008 124.35 33.6215C124.326 33.6698 124.289 33.7121 124.24 33.7483C124.19 33.7845 124.135 33.8087 124.073 33.8208C124.012 33.8208 123.944 33.8087 123.87 33.7845C123.735 33.7483 123.606 33.6698 123.483 33.5491C123.372 33.4284 123.316 33.2895 123.316 33.1326C123.316 33.0118 123.366 32.8066 123.464 32.5168C123.563 32.215 123.692 31.8528 123.852 31.4302C124.024 31.0077 124.221 30.5609 124.443 30.0901C124.48 30.0297 124.511 29.9573 124.535 29.8728C124.56 29.7762 124.578 29.6736 124.591 29.5649C124.615 29.4562 124.628 29.3536 124.628 29.257C124.628 29.1967 124.634 29.1363 124.646 29.0759C124.671 29.0035 124.695 28.9371 124.72 28.8767C124.757 28.8043 124.788 28.756 124.812 28.7318C124.861 28.6352 124.948 28.6111 125.071 28.6594C125.194 28.6956 125.298 28.7801 125.385 28.9129C125.569 29.082 125.662 29.2932 125.662 29.5468C125.674 29.8003 125.612 30.1142 125.477 30.4885C125.428 30.573 125.385 30.6575 125.348 30.742C125.323 30.8145 125.298 30.8809 125.274 30.9413C125.249 30.9896 125.231 31.0318 125.218 31.068C125.206 31.0922 125.2 31.1042 125.2 31.1042C125.249 31.1042 125.36 31.0499 125.532 30.9413C125.705 30.8326 125.908 30.7119 126.142 30.5791C126.327 30.4463 126.487 30.3255 126.622 30.2169C126.77 30.0961 126.893 30.0056 126.991 29.9452C127.09 29.8728 127.151 29.8365 127.176 29.8365C127.225 29.8365 127.287 29.8184 127.361 29.7822C127.435 29.746 127.496 29.7037 127.545 29.6554C127.595 29.6072 127.632 29.583 127.656 29.583C127.693 29.5709 127.712 29.5649 127.712 29.5649C127.712 29.5649 127.736 29.5649 127.785 29.5649C127.835 29.5528 127.884 29.5226 127.933 29.4743C128.032 29.4019 128.161 29.3838 128.321 29.42C128.481 29.4442 128.629 29.5045 128.764 29.6011C128.9 29.6977 128.967 29.8064 128.967 29.9271C128.967 29.9754 128.98 30.0176 129.004 30.0539C129.041 30.078 129.06 30.0901 129.06 30.0901C129.158 30.0901 129.22 30.241 129.244 30.5428C129.281 30.8447 129.251 31.1344 129.152 31.4121C129.152 31.5932 129.115 31.8105 129.041 32.0641C128.98 32.3176 128.924 32.5591 128.875 32.7885C128.777 33.0903 128.709 33.3559 128.672 33.5853C128.635 33.8147 128.629 34.0079 128.653 34.1648C128.678 34.3218 128.721 34.4486 128.783 34.5452C128.832 34.6297 128.832 34.7263 128.783 34.8349C128.733 34.9315 128.635 34.9798 128.487 34.9798Z"
      fill="#F97316"
    />
    <path
      d="M135.195 35.1428C135.059 35.1911 134.961 35.2092 134.899 35.1971C134.85 35.173 134.721 35.0824 134.511 34.9255C134.425 34.7806 134.37 34.6538 134.345 34.5452C134.333 34.4244 134.327 34.2131 134.327 33.9113C134.351 33.7302 134.4 33.4706 134.474 33.1326C134.561 32.7945 134.659 32.4384 134.77 32.0641C134.881 31.6898 134.979 31.3518 135.065 31.0499C135.164 30.7481 135.238 30.5428 135.287 30.4342C135.373 30.1444 135.392 29.9694 135.342 29.909C135.293 29.8365 135.145 29.7883 134.899 29.7641C134.407 29.7037 133.963 29.8607 133.569 30.235C133.175 30.6092 132.781 31.0982 132.388 31.7019C132.092 32.1486 131.914 32.5349 131.852 32.8609C131.803 33.1748 131.797 33.3922 131.833 33.5129C131.87 33.6095 131.957 33.6638 132.092 33.6759C132.227 33.6759 132.375 33.6457 132.535 33.5853C132.708 33.525 132.855 33.4646 132.978 33.4042C133.065 33.3559 133.169 33.3076 133.292 33.2593C133.428 33.199 133.557 33.1446 133.68 33.0964C133.754 33.0964 133.803 33.1205 133.828 33.1688C133.865 33.205 133.883 33.2835 133.883 33.4042C133.883 33.4525 133.902 33.4948 133.939 33.531C133.976 33.5672 134.019 33.5974 134.068 33.6215C134.117 33.6698 134.043 33.7785 133.846 33.9475C133.662 34.1166 133.372 34.3097 132.978 34.527C132.609 34.6116 132.307 34.6538 132.074 34.6538C131.852 34.6538 131.636 34.5753 131.427 34.4184C131.082 34.2131 130.885 33.8811 130.836 33.4223C130.799 32.9515 130.898 32.378 131.132 31.7019C131.366 31.1586 131.624 30.7179 131.907 30.3798C132.191 30.0297 132.492 29.6917 132.812 29.3657C132.862 29.3174 132.972 29.245 133.145 29.1484C133.329 29.0397 133.557 28.9431 133.828 28.8586C134.136 28.762 134.425 28.7016 134.696 28.6775C134.967 28.6534 135.201 28.7077 135.398 28.8405C135.619 28.8888 135.761 28.8827 135.822 28.8224C135.884 28.7499 135.989 28.5326 136.136 28.1704C136.383 27.5668 136.623 26.957 136.857 26.3413C137.091 25.7135 137.343 25.0796 137.614 24.4397C137.737 24.2104 137.811 24.0353 137.835 23.9146C137.872 23.7818 137.915 23.6912 137.965 23.6429H138.316C138.365 23.6429 138.451 23.6852 138.574 23.7697C138.697 23.8542 138.783 23.9689 138.833 24.1138C138.833 24.2224 138.783 24.4639 138.685 24.8382C138.586 25.2004 138.426 25.635 138.205 26.1421C138.008 26.5888 137.811 27.0416 137.614 27.5003C137.429 27.9471 137.251 28.424 137.078 28.931C136.943 29.3053 136.82 29.6072 136.709 29.8365C136.598 30.0659 136.524 30.2651 136.487 30.4342C136.413 30.7481 136.321 31.0318 136.21 31.2853C136.112 31.5268 136.044 31.6958 136.007 31.7924C135.847 32.2512 135.718 32.6255 135.619 32.9153C135.521 33.1929 135.447 33.4284 135.398 33.6215C135.348 33.8026 135.318 33.9898 135.305 34.183C135.305 34.3641 135.324 34.5814 135.361 34.8349C135.361 34.8832 135.355 34.9315 135.342 34.9798C135.33 35.0281 135.281 35.0824 135.195 35.1428Z"
      fill="#F97316"
    />
    <path
      d="M144.923 35.994C144.824 35.994 144.713 35.9155 144.59 35.7585C144.467 35.6016 144.412 35.4507 144.424 35.3058C144.436 35.1126 144.492 34.8349 144.59 34.4727C144.689 34.1105 144.8 33.7423 144.923 33.368C145.046 32.9937 145.157 32.6979 145.255 32.4806C145.304 32.2874 145.347 32.1184 145.384 31.9735C145.434 31.8166 145.464 31.714 145.477 31.6657C145.514 31.6174 145.569 31.4906 145.643 31.2853C145.729 31.0801 145.797 30.8809 145.846 30.6877C145.871 30.5911 145.92 30.41 145.994 30.1444C146.08 29.8667 146.179 29.5468 146.289 29.1846C146.412 28.8224 146.529 28.4662 146.64 28.1161C146.763 27.766 146.868 27.4581 146.954 27.1925C147.04 26.9269 147.096 26.7518 147.12 26.6673C147.219 26.5224 147.293 26.3836 147.342 26.2508C147.391 26.1179 147.422 26.0274 147.434 25.9791C147.508 25.9308 147.551 25.8704 147.564 25.798C147.576 25.7135 147.582 25.6471 147.582 25.5988C147.582 25.5384 147.601 25.4901 147.637 25.4539C147.687 25.4177 147.711 25.3754 147.711 25.3271C147.761 25.2909 147.791 25.2366 147.804 25.1642C147.816 25.0796 147.853 25.0072 147.914 24.9468L148.007 24.639L149.096 24.6208C149.072 24.7657 149.035 24.9468 148.986 25.1642C148.936 25.3694 148.819 25.6471 148.635 25.9972C148.573 26.2387 148.499 26.456 148.413 26.6492C148.339 26.8423 148.308 26.9691 148.321 27.0295C148.296 27.0536 148.241 27.1744 148.155 27.3917C148.081 27.609 147.988 27.8746 147.878 28.1885C147.779 28.5024 147.674 28.8163 147.564 29.1303C147.465 29.4442 147.373 29.7218 147.287 29.9633C147.213 30.1927 147.163 30.3376 147.139 30.398C147.04 30.5911 146.93 30.8749 146.806 31.2491C146.683 31.6234 146.499 32.1305 146.252 32.7704C146.154 32.9635 146.031 33.2533 145.883 33.6397C145.748 34.026 145.637 34.3761 145.551 34.69C145.415 35.1609 145.317 35.4869 145.255 35.668C145.206 35.8612 145.163 35.9638 145.126 35.9759C145.089 36 145.021 36.006 144.923 35.994ZM145.07 25.2004C144.726 25.2124 144.467 25.1943 144.295 25.146C144.135 25.0977 144.079 24.977 144.129 24.7838C144.166 24.639 144.246 24.5303 144.369 24.4579C144.492 24.3854 144.67 24.3311 144.904 24.2949C145.04 24.2707 145.212 24.2405 145.421 24.2043C145.643 24.1681 145.852 24.1319 146.049 24.0957C146.456 24.0474 146.788 24.0051 147.046 23.9689C147.317 23.9327 147.594 23.9025 147.878 23.8783C148.161 23.8542 148.518 23.83 148.949 23.8059C149.306 23.7818 149.607 23.7636 149.854 23.7516C150.112 23.7274 150.241 23.7153 150.241 23.7153C150.278 23.7153 150.408 23.7274 150.629 23.7516C150.851 23.7757 151.091 23.8059 151.349 23.8421C151.608 23.8783 151.799 23.9206 151.922 23.9689C152.205 24.0293 152.408 24.1138 152.531 24.2224C152.667 24.3311 152.759 24.488 152.808 24.6933C152.845 24.8382 152.845 24.9287 152.808 24.9649C152.771 24.9891 152.704 25.0253 152.605 25.0736C152.322 25.1581 152.113 25.2004 151.977 25.2004C151.842 25.2004 151.688 25.1702 151.516 25.1098C151.454 25.0495 151.38 24.9951 151.294 24.9468C151.22 24.8985 151.085 24.8623 150.888 24.8382C150.703 24.802 150.408 24.7718 150.001 24.7476C149.657 24.7838 149.355 24.802 149.096 24.802C148.838 24.802 148.709 24.8321 148.709 24.8925L147.619 24.9468L146.714 25.0374C146.591 25.0495 146.419 25.0676 146.197 25.0917C145.975 25.1038 145.76 25.1219 145.551 25.146C145.341 25.1581 145.181 25.1762 145.07 25.2004Z"
      fill="#F97316"
    />
    <path
      d="M151.348 34.6719C151.25 34.6961 151.12 34.7081 150.96 34.7081C150.8 34.6961 150.659 34.678 150.536 34.6538C150.425 34.6176 150.369 34.5814 150.369 34.5452C150.369 34.4848 150.339 34.4546 150.277 34.4546C150.277 34.4546 150.246 34.4305 150.185 34.3822C150.135 34.3339 150.055 34.2856 149.945 34.2373C149.834 34.0683 149.778 33.8872 149.778 33.694C149.778 33.4887 149.834 33.1688 149.945 32.7342C149.982 32.4323 150.099 32.0822 150.296 31.6838C150.505 31.2733 150.757 30.8567 151.053 30.4342C151.348 30.0116 151.656 29.6313 151.976 29.2932C152.308 28.9552 152.61 28.7077 152.881 28.5507C153.053 28.3817 153.263 28.2912 153.509 28.2791C153.755 28.267 153.989 28.3213 154.211 28.4421C154.334 28.5024 154.457 28.599 154.58 28.7318C154.703 28.8646 154.82 29.0095 154.931 29.1665C155.042 29.3234 155.134 29.4804 155.208 29.6373C155.245 29.7701 155.263 29.8909 155.263 29.9995C155.276 30.0961 155.276 30.2169 155.263 30.3617C155.263 30.5066 155.245 30.7239 155.208 31.0137C155.146 31.231 155.091 31.4966 155.042 31.8105C155.005 32.1244 154.986 32.3961 154.986 32.6255C154.962 32.8549 154.986 33.0179 155.06 33.1145C155.146 33.2111 155.269 33.2171 155.43 33.1326C155.577 33.0601 155.719 33.03 155.854 33.042C155.99 33.042 156.094 33.0782 156.168 33.1507C156.254 33.2231 156.297 33.3318 156.297 33.4767C156.297 33.6215 156.224 33.7725 156.076 33.9294C155.94 34.0743 155.768 34.2011 155.559 34.3097C155.362 34.4063 155.171 34.4546 154.986 34.4546C154.851 34.4546 154.722 34.3761 154.598 34.2192C154.475 34.0502 154.365 33.8509 154.266 33.6215C154.18 33.3801 154.1 33.1507 154.026 32.9334L153.915 32.5168L153.121 33.2593C152.961 33.4284 152.801 33.5853 152.641 33.7302C152.493 33.863 152.401 33.9596 152.364 34.02C152.302 34.1286 152.185 34.2373 152.013 34.3459C151.853 34.4546 151.631 34.5633 151.348 34.6719ZM151.404 33.6034C151.613 33.4827 151.853 33.3076 152.124 33.0782C152.395 32.8368 152.659 32.5772 152.918 32.2995C153.176 32.0098 153.392 31.7441 153.564 31.5027C153.774 31.225 153.934 30.9654 154.044 30.7239C154.155 30.4825 154.235 30.2531 154.285 30.0358C154.235 29.9029 154.155 29.7641 154.044 29.6192C153.934 29.4623 153.835 29.3778 153.749 29.3657C153.478 29.3657 153.189 29.5347 152.881 29.8728C152.585 30.1987 152.296 30.5549 152.013 30.9413C151.964 31.0016 151.896 31.0982 151.81 31.231C151.724 31.3638 151.637 31.4906 151.551 31.6113C151.477 31.72 151.428 31.7924 151.404 31.8287C151.367 31.8769 151.293 32.0158 151.182 32.2452C151.083 32.4625 150.985 32.6859 150.886 32.9153C150.788 33.1326 150.739 33.2775 150.739 33.3499C150.739 33.4223 150.745 33.5008 150.757 33.5853C150.782 33.6698 150.843 33.7242 150.942 33.7483C151.04 33.7725 151.194 33.7242 151.404 33.6034Z"
      fill="#F97316"
    />
    <path
      d="M158.317 35.2696C158.083 35.173 157.862 35.0462 157.652 34.8893C157.443 34.7202 157.308 34.5814 157.246 34.4727C157.246 34.3641 157.265 34.2916 157.302 34.2554C157.338 34.2071 157.443 34.189 157.615 34.2011C157.8 34.2011 158.096 34.2252 158.502 34.2735C158.65 34.2735 158.834 34.2614 159.056 34.2373C159.278 34.2131 159.481 34.1769 159.665 34.1286C159.862 34.0803 159.973 34.02 159.998 33.9475C160.059 33.9475 160.072 33.9294 160.035 33.8932C159.998 33.8449 159.955 33.7966 159.905 33.7483C159.856 33.7483 159.801 33.7302 159.739 33.694C159.678 33.6457 159.622 33.6215 159.573 33.6215C159.573 33.5612 159.511 33.4948 159.388 33.4223C159.278 33.3378 159.161 33.2714 159.037 33.2231C158.767 33.0058 158.533 32.8126 158.336 32.6436C158.139 32.4625 158.065 32.3418 158.114 32.2814C158.114 32.2331 158.114 32.209 158.114 32.209V32.1909C158.028 32.1909 157.929 32.0701 157.819 31.8287C157.72 31.5872 157.671 31.3699 157.671 31.1767C157.671 31.0318 157.714 30.8507 157.8 30.6334C157.886 30.404 158.003 30.1686 158.151 29.9271C158.299 29.6856 158.453 29.4864 158.613 29.3295C158.834 29.1242 159.111 28.9069 159.444 28.6775C159.776 28.436 160.102 28.2248 160.423 28.0437C160.755 27.8505 161.032 27.7237 161.254 27.6633C161.475 27.5788 161.678 27.5366 161.863 27.5366C162.06 27.5366 162.232 27.5788 162.38 27.6633C162.503 27.7237 162.614 27.8143 162.713 27.935C162.823 28.0436 162.916 28.1583 162.99 28.2791C163.076 28.3877 163.131 28.4843 163.156 28.5688C163.156 28.7137 163.143 28.8767 163.119 29.0578C163.094 29.2268 163.057 29.3778 163.008 29.5106C162.971 29.6434 162.91 29.7098 162.823 29.7098C162.823 29.7098 162.805 29.7158 162.768 29.7279C162.743 29.7279 162.731 29.7581 162.731 29.8184C162.731 29.9392 162.639 30.078 162.454 30.235C162.22 30.3919 162.017 30.4885 161.845 30.5247C161.672 30.5489 161.568 30.4825 161.531 30.3255C161.494 30.2772 161.469 30.235 161.457 30.1987C161.444 30.1625 161.414 30.1444 161.364 30.1444C161.364 30.1444 161.346 30.1263 161.309 30.0901C161.272 30.0539 161.254 29.9935 161.254 29.909C161.254 29.8607 161.272 29.8184 161.309 29.7822C161.346 29.7339 161.364 29.7098 161.364 29.7098C161.426 29.7098 161.506 29.6434 161.604 29.5106C161.703 29.3657 161.789 29.2148 161.863 29.0578C161.949 28.8888 161.992 28.7741 161.992 28.7137C161.992 28.6413 161.98 28.599 161.955 28.587C161.955 28.587 161.888 28.5688 161.789 28.5688C161.617 28.6413 161.408 28.7379 161.161 28.8586C160.915 28.9793 160.681 29.1001 160.459 29.2208C160.25 29.3295 160.096 29.4321 159.998 29.5287C159.949 29.6132 159.918 29.6675 159.905 29.6917C159.905 29.6917 159.862 29.7098 159.813 29.7098C159.813 29.6615 159.77 29.6856 159.684 29.7822C159.61 29.8667 159.511 29.9875 159.388 30.1444C159.278 30.3014 159.167 30.4583 159.056 30.6153C158.957 30.7602 158.884 30.8688 158.834 30.9413C158.81 30.9654 158.779 31.0378 158.742 31.1586C158.717 31.2672 158.705 31.3699 158.705 31.4665C158.656 31.6113 158.662 31.714 158.724 31.7743C158.785 31.8226 158.921 31.9313 159.13 32.1003C159.561 32.4142 159.899 32.6738 160.146 32.879C160.392 33.0843 160.576 33.2533 160.7 33.3861C160.823 33.5189 160.897 33.6397 160.921 33.7483C161.143 34.1105 161.211 34.3882 161.124 34.5814C161.038 34.7746 160.829 34.9436 160.496 35.0885C160.373 35.1488 160.17 35.1971 159.887 35.2333C159.604 35.2696 159.315 35.2877 159.019 35.2877C158.724 35.2997 158.49 35.2937 158.317 35.2696Z"
      fill="#F97316"
    />
    <path
      d="M163.614 34.7987C163.491 34.7142 163.399 34.6357 163.337 34.5633C163.276 34.4908 163.251 34.3882 163.263 34.2554C163.288 34.0743 163.325 33.8872 163.374 33.694C163.423 33.4887 163.485 33.2895 163.559 33.0964C163.596 32.879 163.639 32.6617 163.688 32.4444C163.75 32.2271 163.848 32.0218 163.983 31.8287C164.144 31.3819 164.31 30.9413 164.482 30.5066C164.654 30.0599 164.802 29.5951 164.925 29.1121C165.11 28.6775 165.276 28.2912 165.424 27.9531C165.584 27.615 165.775 27.1804 165.996 26.6492C166.12 26.3715 166.224 26.0636 166.31 25.7256C166.409 25.3754 166.557 25.0676 166.754 24.802C166.84 24.6933 166.901 24.6027 166.938 24.5303C166.988 24.4458 167.037 24.3673 167.086 24.2949C167.111 24.2224 167.191 24.1983 167.326 24.2224C167.474 24.2466 167.579 24.3009 167.64 24.3854C167.702 24.3733 167.776 24.4518 167.862 24.6208C167.948 24.7899 167.979 24.9227 167.954 25.0193C167.954 25.1521 167.905 25.297 167.806 25.4539C167.757 25.5022 167.708 25.5746 167.659 25.6712C167.609 25.7557 167.535 25.8704 167.437 26.0153C167.388 26.1723 167.338 26.3292 167.289 26.4862C167.24 26.6431 167.185 26.788 167.123 26.9208C167.061 27.0536 166.994 27.1864 166.92 27.3192C166.846 27.4521 166.797 27.5607 166.772 27.6452C166.661 27.9229 166.538 28.1946 166.403 28.4602C166.28 28.7137 166.169 28.9854 166.07 29.2751C165.972 29.5528 165.867 29.8486 165.756 30.1625C165.658 30.4644 165.522 30.7541 165.35 31.0318C165.264 31.1525 165.196 31.3155 165.147 31.5208C165.098 31.726 165.048 31.9252 164.999 32.1184C164.913 32.3357 164.833 32.5349 164.759 32.716C164.698 32.8971 164.667 33.0118 164.667 33.0601C164.581 33.3257 164.513 33.5914 164.464 33.857C164.414 34.1105 164.334 34.3339 164.224 34.527C164.211 34.7082 164.156 34.8289 164.057 34.8893C163.971 34.9496 163.823 34.9194 163.614 34.7987ZM168.028 35.0885C167.831 35.0643 167.683 35.0281 167.585 34.9798C167.486 34.9194 167.302 34.7927 167.031 34.5995C166.883 34.4546 166.68 34.2313 166.421 33.9294C166.163 33.6276 165.904 33.3076 165.646 32.9696C165.387 32.6195 165.172 32.3237 164.999 32.0822L165.756 31.0861C165.916 31.2793 166.046 31.4604 166.144 31.6294C166.243 31.7985 166.323 31.9132 166.384 31.9735C166.667 32.384 166.889 32.716 167.049 32.9696C167.221 33.2231 167.375 33.4284 167.511 33.5853C167.646 33.7423 167.788 33.8811 167.936 34.0019C168.096 34.1226 168.293 34.2494 168.527 34.3822C168.563 34.4063 168.6 34.4425 168.637 34.4908C168.674 34.5391 168.687 34.6116 168.674 34.7081C168.625 34.841 168.57 34.9255 168.508 34.9617C168.459 34.9858 168.299 35.0281 168.028 35.0885ZM164.944 31.883C164.87 31.6777 164.895 31.4725 165.018 31.2672C165.153 31.0499 165.301 30.899 165.461 30.8145C165.51 30.73 165.559 30.6756 165.609 30.6515C165.67 30.6153 165.707 30.573 165.719 30.5247C165.744 30.4764 165.806 30.41 165.904 30.3255C166.015 30.241 166.113 30.1625 166.2 30.0901C166.397 29.9694 166.618 29.8245 166.864 29.6554C167.123 29.4743 167.369 29.2932 167.603 29.1121C167.837 28.931 168.034 28.7741 168.194 28.6413C168.366 28.5085 168.471 28.424 168.508 28.3877C168.545 28.3394 168.594 28.3093 168.656 28.2972C168.73 28.273 168.822 28.2851 168.933 28.3334C169.081 28.3696 169.179 28.43 169.228 28.5145C169.278 28.587 169.302 28.7318 169.302 28.9492C169.339 29.082 169.284 29.2268 169.136 29.3838C169.001 29.5287 168.791 29.6917 168.508 29.8728C168.41 29.9331 168.274 30.0237 168.102 30.1444C167.942 30.2651 167.8 30.3798 167.677 30.4885C167.591 30.5368 167.462 30.6213 167.289 30.742C167.129 30.8507 166.988 30.9594 166.864 31.068C166.766 31.1284 166.637 31.2371 166.477 31.394C166.317 31.5389 166.157 31.6476 165.996 31.72C165.602 32.0822 165.344 32.2754 165.221 32.2995C165.098 32.3237 165.005 32.1848 164.944 31.883Z"
      fill="#F97316"
    />
    <path
      d="M171.929 34.9436C171.313 34.9436 170.864 34.7263 170.581 34.2916C170.495 34.1709 170.451 34.0502 170.451 33.9294C170.464 33.7966 170.501 33.7061 170.562 33.6578C170.636 33.6095 170.722 33.6517 170.821 33.7845C170.993 33.8811 171.239 33.9294 171.56 33.9294C171.72 33.9294 171.886 33.9173 172.058 33.8932C172.231 33.857 172.403 33.8087 172.575 33.7483C172.76 33.6638 172.883 33.5914 172.945 33.531C173.006 33.4586 172.994 33.3982 172.908 33.3499H172.926C172.606 33.2654 172.28 33.1326 171.947 32.9515C171.627 32.7583 171.35 32.5531 171.116 32.3357C170.882 32.1063 170.747 31.9011 170.71 31.72C170.612 31.3457 170.636 30.9654 170.784 30.5791C170.932 30.1806 171.141 29.8305 171.412 29.5287C171.51 29.4683 171.633 29.3959 171.781 29.3114C171.929 29.2148 172.046 29.1604 172.132 29.1484V29.1665C172.366 28.925 172.649 28.7318 172.982 28.587C173.326 28.4421 173.689 28.3093 174.071 28.1885L174.348 28.1523C174.496 28.1282 174.619 28.1161 174.718 28.1161C174.718 28.1161 174.73 28.1282 174.791 28.1523C174.853 28.1644 174.908 28.1765 174.958 28.1885C175.031 28.2248 175.093 28.2429 175.142 28.2429C175.302 28.267 175.45 28.3394 175.585 28.4602C175.721 28.5809 175.826 28.7258 175.899 28.8948C175.986 29.0518 176.016 29.2027 175.992 29.3476C175.967 29.577 175.893 29.7822 175.77 29.9633C175.659 30.1444 175.524 30.247 175.364 30.2712C175.389 30.2591 175.37 30.241 175.308 30.2169C175.259 30.1806 175.204 30.1444 175.142 30.1082L175.087 30.1444C175.087 30.1444 175.081 30.1323 175.068 30.1082C175.068 30.072 175.056 30.0297 175.031 29.9814C174.995 29.909 174.976 29.8305 174.976 29.746C174.976 29.6494 174.982 29.5468 174.995 29.4381C175.019 29.3053 175.019 29.2268 174.995 29.2027C174.982 29.1785 174.902 29.1604 174.754 29.1484C174.582 29.1121 174.33 29.1423 173.997 29.2389C173.677 29.3355 173.406 29.4683 173.185 29.6373C172.914 29.8064 172.686 29.9694 172.501 30.1263C172.317 30.2712 172.169 30.4161 172.058 30.5609C171.947 30.6938 171.849 30.8507 171.763 31.0318C171.701 31.1163 171.646 31.2008 171.596 31.2853C171.56 31.3578 171.541 31.4242 171.541 31.4846C171.541 31.6174 171.64 31.7562 171.837 31.9011C172.046 32.0339 172.354 32.1909 172.76 32.372C173.08 32.5048 173.351 32.6496 173.573 32.8066C173.794 32.9635 173.948 33.1446 174.034 33.3499C174.059 33.3982 174.065 33.4586 174.053 33.531C174.053 33.5914 174.04 33.6336 174.016 33.6578C174.04 33.6819 174.053 33.7121 174.053 33.7121V33.694C174.151 33.8389 174.151 33.9898 174.053 34.1467C173.966 34.3037 173.813 34.4425 173.591 34.5633C173.382 34.6719 173.123 34.7564 172.815 34.8168H172.834C172.674 34.8651 172.514 34.9013 172.354 34.9255C172.206 34.9375 172.064 34.9436 171.929 34.9436Z"
      fill="#F97316"
    />
  </svg>
);

export const CameraIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="10.5" fill="white" stroke="#EFEFEF" />
    <path
      d="M8.4135 8.0876C8.3235 8.23006 8.20341 8.35109 8.06167 8.44222C7.91993 8.53334 7.75996 8.59235 7.593 8.6151C7.403 8.6421 7.2145 8.6711 7.026 8.7026C6.4995 8.7901 6.125 9.2536 6.125 9.7871V14.0001C6.125 14.2985 6.24353 14.5846 6.4545 14.7956C6.66548 15.0066 6.95163 15.1251 7.25 15.1251H14.75C15.0484 15.1251 15.3345 15.0066 15.5455 14.7956C15.7565 14.5846 15.875 14.2985 15.875 14.0001V9.7871C15.875 9.2536 15.5 8.7901 14.974 8.7026C14.7854 8.67117 14.5963 8.642 14.407 8.6151C14.2401 8.59228 14.0803 8.53324 13.9386 8.44212C13.797 8.351 13.677 8.23 13.587 8.0876L13.176 7.4296C13.0837 7.27965 12.9566 7.15415 12.8055 7.06372C12.6544 6.97329 12.4838 6.9206 12.308 6.9101C11.4366 6.8633 10.5634 6.8633 9.692 6.9101C9.51623 6.9206 9.34557 6.97329 9.19448 7.06372C9.04339 7.15415 8.91631 7.27965 8.824 7.4296L8.4135 8.0876Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.25 11.375C13.25 11.9717 13.0129 12.544 12.591 12.966C12.169 13.3879 11.5967 13.625 11 13.625C10.4033 13.625 9.83097 13.3879 9.40901 12.966C8.98705 12.544 8.75 11.9717 8.75 11.375C8.75 10.7783 8.98705 10.206 9.40901 9.78401C9.83097 9.36205 10.4033 9.125 11 9.125C11.5967 9.125 12.169 9.36205 12.591 9.78401C13.0129 10.206 13.25 10.7783 13.25 11.375ZM14.375 10.25H14.379V10.254H14.375V10.25Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CloseIcon = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="24" fill="#1E3A8A" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4184 14.4184C14.9763 13.8605 15.8808 13.8605 16.4387 14.4184L33.5817 31.5612C34.1394 32.1192 34.1394 33.0237 33.5817 33.5817C33.0237 34.1394 32.1192 34.1394 31.5612 33.5817L14.4184 16.4387C13.8605 15.8808 13.8605 14.9763 14.4184 14.4184Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.5817 14.4184C33.0237 13.8605 32.1192 13.8605 31.5612 14.4184L14.4184 31.5612C13.8605 32.1192 13.8605 33.0237 14.4184 33.5817C14.9763 34.1394 15.8808 34.1394 16.4387 33.5817L33.5817 16.4387C34.1394 15.8808 34.1394 14.9763 33.5817 14.4184Z"
      fill="white"
    />
  </svg>
);

export const BackArrowIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 15.8334L6.66667 10.0001L12.5 4.16675"
      stroke="#1E3A8A"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlainClockIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10"
      r="7.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
    />
    <path
      d="M10 5.5V10L13 12"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CheckedInIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.875 8.33523V5.25218C6.875 4.76157 7.07254 4.29106 7.42417 3.94415C7.77581 3.59724 8.25272 3.40234 8.75 3.40234H13.75C14.2473 3.40234 14.7242 3.59724 15.0758 3.94415C15.4275 4.29106 15.625 4.76157 15.625 5.25218V16.3512C15.625 16.8418 15.4275 17.3123 15.0758 17.6592C14.7242 18.0061 14.2473 18.201 13.75 18.201H8.75C8.25272 18.201 7.77581 18.0061 7.42417 17.6592C7.07254 17.3123 6.875 16.8418 6.875 16.3512V13.2681"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 13.2669L12.5 10.8004M12.5 10.8004L10 8.33398M12.5 10.8004H1.875"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CoffeeIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2096 9H16.368C17.9113 9 18.3696 9.22083 18.3321 10.32C18.2713 12.1392 17.4505 14.2533 14.168 14.8333"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.95662 17.4298C2.14495 15.2673 1.73078 12.2007 1.66912 9.00065C1.64328 7.61815 2.04412 7.33398 3.88412 7.33398H12.7858C14.6258 7.33398 15.0274 7.61815 15.0008 9.00065C14.9391 12.2007 14.5258 15.2673 11.7133 17.4298C10.9133 18.0448 10.2383 18.1673 9.10078 18.1673H7.56912C6.43245 18.1673 5.75745 18.0457 4.95662 17.4298Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33594 7.33398V11.5007M9.42677 2.33398C8.97094 2.61648 8.33594 3.58398 8.33594 4.83398M6.28594 3.58398C6.28594 3.58398 5.83594 4.00065 5.83594 4.83398M11.6701 3.58398C11.4426 3.72565 11.2526 4.41732 11.2526 4.83398M7.08927 13.8315L7.3326 12.2882C7.40427 11.8365 7.83094 11.5007 8.3351 11.5007C8.83844 11.5007 9.26594 11.8365 9.33677 12.2882L9.5801 13.8315C9.71177 14.6623 6.97427 14.5615 7.08927 13.8315Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CarIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.08203 10L3.7487 10.8333"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.9167 10.416L16.25 10.8327"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66797 14.5833L6.87269 14.0715C7.17714 13.3104 7.32937 12.9298 7.64681 12.7149C7.96424 12.5 8.37414 12.5 9.19389 12.5H10.8087C11.6285 12.5 12.0384 12.5 12.3558 12.7149C12.6732 12.9298 12.8255 13.3104 13.1299 14.0715L13.3346 14.5833"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.66797 14.166V16.5677C1.66797 16.8833 1.86859 17.1718 2.1862 17.313C2.39229 17.4046 2.58912 17.4993 2.82679 17.4993H4.25915C4.49682 17.4993 4.69365 17.4046 4.89974 17.313C5.21734 17.1718 5.41797 16.8833 5.41797 16.5677V14.9993"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.582 14.9993V16.5677C14.582 16.8833 14.7827 17.1718 15.1003 17.313C15.3064 17.4046 15.5032 17.4993 15.7409 17.4993H17.1732C17.4109 17.4993 17.6077 17.4046 17.8138 17.313C18.1314 17.1718 18.332 16.8833 18.332 16.5677V14.166"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.668 7.08268L17.5013 6.66602"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.33333 7.08268L2.5 6.66602"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.75 7.5L4.65692 4.77924C5.0236 3.67921 5.20693 3.12919 5.64342 2.8146C6.07989 2.5 6.65966 2.5 7.8192 2.5H12.1808C13.3403 2.5 13.9201 2.5 14.3566 2.8146C14.7931 3.12919 14.9764 3.67921 15.3431 4.77924L16.25 7.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M3.7513 7.5H16.2513C17.049 8.34458 18.3346 9.52075 18.3346 10.833V13.7252C18.3346 14.2006 18.0184 14.6007 17.5986 14.6562L15.0013 15H5.0013L2.40394 14.6562C1.98426 14.6007 1.66797 14.2006 1.66797 13.7252V10.833C1.66797 9.52075 2.95363 8.34458 3.7513 7.5Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);

export const PlusIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1V11M11 6H1"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProgressIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 17.5H8.33333C5.58347 17.5 4.20854 17.5 3.35427 16.6457C2.5 15.7914 2.5 14.4165 2.5 11.6667V2.5"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M10.834 8.33398V17.5007"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 10.834V17.5007"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66602 10.834V16.6673"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5 6.65512C15.9667 6.65512 14.3268 6.86812 13.2309 5.41057C11.9832 3.75117 9.6835 3.75117 8.43575 5.41057C7.33985 6.86812 5.70002 6.65512 4.16667 6.65512H2.5"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const StatsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 10.9375C2.5 10.42 2.92 10 3.4375 10H5.3125C5.83 10 6.25 10.42 6.25 10.9375V16.5625C6.25 17.08 5.83 17.5 5.3125 17.5H3.4375C3.18886 17.5 2.9504 17.4012 2.77459 17.2254C2.59877 17.0496 2.5 16.8111 2.5 16.5625V10.9375ZM8.125 7.1875C8.125 6.67 8.545 6.25 9.0625 6.25H10.9375C11.455 6.25 11.875 6.67 11.875 7.1875V16.5625C11.875 17.08 11.455 17.5 10.9375 17.5H9.0625C8.81386 17.5 8.5754 17.4012 8.39959 17.2254C8.22377 17.0496 8.125 16.8111 8.125 16.5625V7.1875ZM13.75 3.4375C13.75 2.92 14.17 2.5 14.6875 2.5H16.5625C17.08 2.5 17.5 2.92 17.5 3.4375V16.5625C17.5 17.08 17.08 17.5 16.5625 17.5H14.6875C14.4389 17.5 14.2004 17.4012 14.0246 17.2254C13.8488 17.0496 13.75 16.8111 13.75 16.5625V3.4375Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const TaskManagement = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 3.5C5.9442 3.54667 5.01661 3.71984 4.37477 4.36227C3.49609 5.24177 3.49609 6.6573 3.49609 9.48836V15.9944C3.49609 18.8255 3.49609 20.241 4.37477 21.1205C5.25345 22 6.66767 22 9.49609 22H14.4961C17.3245 22 18.7387 22 19.6174 21.1205C20.4961 20.241 20.4961 18.8255 20.4961 15.9944V9.48836C20.4961 6.6573 20.4961 5.24177 19.6174 4.36228C18.9756 3.71984 18.048 3.54667 16.4922 3.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
    />
    <path
      d="M7.49609 3.75C7.49609 2.7835 8.2796 2 9.24609 2H14.7461C15.7126 2 16.4961 2.7835 16.4961 3.75C16.4961 4.7165 15.7126 5.5 14.7461 5.5H9.24609C8.2796 5.5 7.49609 4.7165 7.49609 3.75Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M13.5 11H17"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7 12C7 12 7.5 12 8 13C8 13 9.58824 10.5 11 10"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.5 17H17"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M8 17H9"
      stroke="#1E3A8A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const MinusIcon = (
  <svg
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33203 1H10.6654"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ImageClose = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#1E3A8A" />
    <path
      d="M5.5 10.5L10.5 5.5M5.5 5.5L10.5 10.5"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ImageIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="#000000" strokeWidth="1.6"/>
    <circle cx="9" cy="10" r="2" stroke="#000000" strokeWidth="1.6"/>
    <path d="M4.5 17L9.5 12.5L12.5 15.5L16.5 11.5L19.5 14.5" stroke="#000000" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TickIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#1E3A8A" />
    <path
      d="M4.875 8.3125L7.375 10.8125L11.125 5.1875"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Clockicon = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      d="M30 21V30H36.75M43.5 30C43.5 31.7728 43.1508 33.5283 42.4724 35.1662C41.7939 36.8041 40.7995 38.2923 39.5459 39.5459C38.2923 40.7995 36.8041 41.7939 35.1662 42.4724C33.5283 43.1508 31.7728 43.5 30 43.5C28.2272 43.5 26.4717 43.1508 24.8338 42.4724C23.1959 41.7939 21.7076 40.7995 20.4541 39.5459C19.2005 38.2923 18.2061 36.8041 17.5276 35.1662C16.8492 33.5283 16.5 31.7728 16.5 30C16.5 26.4196 17.9223 22.9858 20.4541 20.4541C22.9858 17.9223 26.4196 16.5 30 16.5C33.5804 16.5 37.0142 17.9223 39.5459 20.4541C42.0777 22.9858 43.5 26.4196 43.5 30Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CupIcon = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      d="M39.377 27H41.462C44.24 27 45.065 27.3975 44.9975 29.376C44.888 32.6505 43.4105 36.456 37.502 37.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.9215 42.1725C15.8605 38.28 15.115 32.76 15.004 27C14.9575 24.5115 15.679 24 18.991 24H35.014C38.326 24 39.049 24.5115 39.001 27C38.89 32.76 38.146 38.28 33.0835 42.1725C31.6435 43.2795 30.4285 43.5 28.381 43.5H25.624C23.578 43.5 22.363 43.281 20.9215 42.1725Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.0039 24V31.5M28.9674 15C28.1469 15.5085 27.0039 17.25 27.0039 19.5M23.3139 17.25C23.3139 17.25 22.5039 18 22.5039 19.5M33.0054 17.25C32.5959 17.505 32.2539 18.75 32.2539 19.5M24.7599 35.6955L25.1979 32.9175C25.3269 32.1045 26.0949 31.5 27.0024 31.5C27.9084 31.5 28.6779 32.1045 28.8054 32.9175L29.2434 35.6955C29.4804 37.191 24.5529 37.0095 24.7599 35.6955Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CarsIcon = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      d="M16.2012 30.4004L19.2012 31.9081"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M43.1992 30.4004L40.1992 31.9081"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.6992 37.9392L24.0677 37.1984C24.6157 36.0968 24.8897 35.546 25.4611 35.2349C26.0325 34.9238 26.7703 34.9238 28.2459 34.9238H31.1526C32.6281 34.9238 33.366 34.9238 33.9373 35.2349C34.5087 35.546 34.7827 36.0968 35.3307 37.1984L35.6992 37.9392"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.2012 37.9375V41.1964C16.2012 41.6246 16.5222 42.0162 17.0303 42.2077C17.3601 42.332 17.675 42.4606 18.0553 42.4606H20.3471C20.7273 42.4606 21.0423 42.332 21.372 42.2077C21.8802 42.0162 22.2012 41.6246 22.2012 41.1964V39.0683"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.1992 39.0683V41.1964C37.1992 41.6246 37.5203 42.0162 38.0284 42.2077C38.3582 42.332 38.6731 42.4606 39.0534 42.4606H41.3451C41.7254 42.4606 42.0403 42.332 42.37 42.2077C42.8782 42.0162 43.1992 41.6246 43.1992 41.1964V37.9375"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M40.1992 25.8768L41.6992 24.3691"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.1992 25.8768L17.6992 24.3691"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.1992 25.8764L20.7228 21.7743C21.3389 20.1158 21.6469 19.2865 22.3802 18.8122C23.1134 18.3379 24.0874 18.3379 26.0355 18.3379H33.363C35.311 18.3379 36.285 18.3379 37.0183 18.8122C37.7516 19.2865 38.0596 20.1158 38.6756 21.7743L40.1992 25.8764"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M19.5762 25.877H39.8262C41.1184 27.2352 43.2012 29.1267 43.2012 31.2371V35.8883C43.2012 36.6529 42.6888 37.2963 42.0089 37.3857L37.8012 37.9385H21.6012L17.3934 37.3857C16.7136 37.2963 16.2012 36.6529 16.2012 35.8883V31.2371C16.2012 29.1267 18.2839 27.2352 19.5762 25.877Z"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);

export const NextArrow = (
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 1.5L8.75 9L1.25 16.5"
      stroke="#1E3A8A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SimpleCross = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 18L18 6M6 6L18 18"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SimplePlus = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3.75C12.1989 3.75 12.3897 3.82902 12.5303 3.96967C12.671 4.11032 12.75 4.30109 12.75 4.5V11.25H19.5C19.6989 11.25 19.8897 11.329 20.0303 11.4697C20.171 11.6103 20.25 11.8011 20.25 12C20.25 12.1989 20.171 12.3897 20.0303 12.5303C19.8897 12.671 19.6989 12.75 19.5 12.75H12.75V19.5C12.75 19.6989 12.671 19.8897 12.5303 20.0303C12.3897 20.171 12.1989 20.25 12 20.25C11.8011 20.25 11.6103 20.171 11.4697 20.0303C11.329 19.8897 11.25 19.6989 11.25 19.5V12.75H4.5C4.30109 12.75 4.11032 12.671 3.96967 12.5303C3.82902 12.3897 3.75 12.1989 3.75 12C3.75 11.8011 3.82902 11.6103 3.96967 11.4697C4.11032 11.329 4.30109 11.25 4.5 11.25H11.25V4.5C11.25 4.30109 11.329 4.11032 11.4697 3.96967C11.6103 3.82902 11.8011 3.75 12 3.75Z"
      fill="#4B5563"
    />
  </svg>
);

export const SuccessIcon = (
  <svg
    width="156"
    height="157"
    viewBox="0 0 156 157"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1562_166)">
      <path
        d="M14.5813 35.4508C4.49868 50.0286 -0.192688 67.6371 1.30715 85.2737C2.80698 102.91 10.4051 119.483 22.806 132.165C35.2068 144.848 51.6425 152.856 69.3105 154.823C86.9784 156.789 104.785 152.594 119.693 142.951C134.601 133.309 145.688 118.816 151.064 101.945C156.439 85.0741 155.77 66.8689 149.171 50.4339C142.572 33.9989 130.45 20.3518 114.874 11.8197C99.2981 3.28751 81.2316 0.398634 63.7552 3.6456"
        stroke="#1E3A8A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.6403 20.9844C25.0469 23.2118 22.6055 25.6087 20.332 28.1591"
        stroke="#1E3A8A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M137.922 104.399C152.043 71.391 136.614 33.2362 103.46 19.1777C70.3057 5.11913 31.9819 20.4805 17.861 53.4882C3.74017 86.4959 19.1696 124.651 52.3235 138.709C85.4775 152.768 123.801 137.406 137.922 104.399Z"
        fill="#1E3A8A"
      />
      <path
        d="M47.75 72.2206L72.4896 100.21L112.982 43.0996"
        stroke="white"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1562_166">
        <rect width="156" height="157" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DollarIcon = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#EEF0F6" />
    <path
      d="M30 21V39M25.5 34.773L26.8185 35.7615C28.575 37.08 31.4235 37.08 33.1815 35.7615C34.9395 34.443 34.9395 32.307 33.1815 30.9885C32.304 30.3285 31.152 30 30 30C28.9125 30 27.825 29.67 26.9955 29.0115C25.3365 27.693 25.3365 25.557 26.9955 24.2385C28.6545 22.92 31.3455 22.92 33.0045 24.2385L33.627 24.7335M43.5 30C43.5 31.7728 43.1508 33.5283 42.4724 35.1662C41.7939 36.8041 40.7995 38.2923 39.5459 39.5459C38.2923 40.7995 36.8041 41.7939 35.1662 42.4724C33.5283 43.1508 31.7728 43.5 30 43.5C28.2272 43.5 26.4717 43.1508 24.8338 42.4724C23.1959 41.7939 21.7076 40.7995 20.4541 39.5459C19.2005 38.2923 18.2061 36.8041 17.5276 35.1662C16.8492 33.5283 16.5 31.7728 16.5 30C16.5 26.4196 17.9223 22.9858 20.4541 20.4541C22.9858 17.9223 26.4196 16.5 30 16.5C33.5804 16.5 37.0142 17.9223 39.5459 20.4541C42.0777 22.9858 43.5 26.4196 43.5 30Z"
      stroke="#1E3A8A"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SelectedRadio = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9" stroke="#1E3A8A" stroke-width="2" />
    <circle cx="12" cy="12" r="6" fill="#1E3A8A" />
  </svg>
);

export const UnselectedRadio = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9" stroke="#B7B7B7" stroke-width="2" />
  </svg>
);

export const ThreeDotIcon = (
  <svg
    width="14"
    height="5"
    viewBox="0 0 14 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.44 4.14C1.98667 4.14 1.6 3.98667 1.28 3.68C0.96 3.36 0.8 2.96 0.8 2.48C0.8 1.97333 0.96 1.57333 1.28 1.28C1.6 0.973333 1.98667 0.82 2.44 0.82C2.89333 0.82 3.28 0.973333 3.6 1.28C3.92 1.57333 4.08 1.97333 4.08 2.48C4.08 2.96 3.92 3.36 3.6 3.68C3.28 3.98667 2.89333 4.14 2.44 4.14ZM7.32281 4.14C6.86948 4.14 6.48281 3.98667 6.16281 3.68C5.84281 3.36 5.68281 2.96 5.68281 2.48C5.68281 1.97333 5.84281 1.57333 6.16281 1.28C6.48281 0.973333 6.86948 0.82 7.32281 0.82C7.77615 0.82 8.16281 0.973333 8.48281 1.28C8.80281 1.57333 8.96281 1.97333 8.96281 2.48C8.96281 2.96 8.80281 3.36 8.48281 3.68C8.16281 3.98667 7.77615 4.14 7.32281 4.14ZM12.2056 4.14C11.7523 4.14 11.3656 3.98667 11.0456 3.68C10.7256 3.36 10.5656 2.96 10.5656 2.48C10.5656 1.97333 10.7256 1.57333 11.0456 1.28C11.3656 0.973333 11.7523 0.82 12.2056 0.82C12.659 0.82 13.0456 0.973333 13.3656 1.28C13.6856 1.57333 13.8456 1.97333 13.8456 2.48C13.8456 2.96 13.6856 3.36 13.3656 3.68C13.0456 3.98667 12.659 4.14 12.2056 4.14Z"
      fill="black"
    />
  </svg>
);

export const PdfAttachmentIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 9.16602C15.8333 8.48477 15.8333 7.85818 15.7065 7.5519C15.5796 7.24562 15.3387 7.00476 14.857 6.52304L10.9099 2.57592C10.4942 2.16018 10.2863 1.95231 10.0287 1.82914C9.97517 1.80352 9.92033 1.78078 9.86433 1.76102C9.59508 1.66602 9.30117 1.66602 8.71317 1.66602C6.00902 1.66602 4.65692 1.66602 3.74111 2.40441C3.55609 2.55358 3.38757 2.72211 3.23839 2.90712C2.5 3.82294 2.5 5.17503 2.5 7.87922V11.666C2.5 14.8087 2.5 16.3801 3.47631 17.3563C4.45262 18.3327 6.02397 18.3327 9.16667 18.3327H15.8333M10 2.08268V2.49935C10 4.85637 10 6.03488 10.7323 6.76712C11.4645 7.49935 12.643 7.49935 15 7.49935H15.4167"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.4987 11.666H15.832C15.3718 11.666 14.9987 12.0391 14.9987 12.4993V13.7493M14.9987 13.7493V15.8327M14.9987 13.7493H17.082M5.83203 15.8327V14.166M5.83203 14.166V11.666H7.08203C7.77239 11.666 8.33203 12.2257 8.33203 12.916C8.33203 13.6063 7.77239 14.166 7.08203 14.166H5.83203ZM10.4154 11.666H11.4868C12.2758 11.666 12.9154 12.2878 12.9154 13.0549V14.4438C12.9154 15.2108 12.2758 15.8327 11.4868 15.8327H10.4154V11.666Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
